import { isMobile as le } from "@swapin-hub/utils";
import { c as g2, i as p1, g as de, O as pe, w as ge, h as me, a as be } from "./createConfig-Cm6rY036.js";
import { g as N, U as R, S as s2, C as L0, n as c2, P as X0, R as w0, W as xe } from "./plugin-DK3uqrH4.js";
function we(e, t) {
  for (var i = 0; i < t.length; i++) {
    const a = t[i];
    if (typeof a != "string" && !Array.isArray(a)) {
      for (const o in a)
        if (o !== "default" && !(o in e)) {
          const s = Object.getOwnPropertyDescriptor(a, o);
          s && Object.defineProperty(e, o, s.get ? s : {
            enumerable: !0,
            get: () => a[o]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
function P2(e) {
  return {
    formatters: void 0,
    fees: void 0,
    serializers: void 0,
    ...e
  };
}
function ye(e) {
  const { chain: t } = e, i = t.rpcUrls.default.http[0];
  if (!e.transports)
    return [i];
  const a = e.transports?.[t.id]?.({ chain: t });
  return (a?.value?.transports || [a]).map(({ value: s }) => s?.url || i);
}
const g1 = /* @__PURE__ */ P2({
  id: 56,
  name: "BNB Smart Chain",
  nativeCurrency: {
    decimals: 18,
    name: "BNB",
    symbol: "BNB"
  },
  rpcUrls: {
    default: { http: ["https://rpc.ankr.com/bsc"] }
  },
  blockExplorers: {
    default: {
      name: "BscScan",
      url: "https://bscscan.com",
      apiUrl: "https://api.bscscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 15921452
    }
  }
}), Q0 = /* @__PURE__ */ P2({
  id: 97,
  name: "Binance Smart Chain Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "BNB",
    symbol: "tBNB"
  },
  rpcUrls: {
    default: { http: ["https://data-seed-prebsc-1-s1.bnbchain.org:8545"] }
  },
  blockExplorers: {
    default: {
      name: "BscScan",
      url: "https://testnet.bscscan.com",
      apiUrl: "https://api-testnet.bscscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 17422483
    }
  },
  testnet: !0
}), m1 = /* @__PURE__ */ P2({
  id: 1,
  name: "Ethereum",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://eth.merkle.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://etherscan.io",
      apiUrl: "https://api.etherscan.io/api"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    ensUniversalResolver: {
      address: "0xce01f8eee7E479C928F8919abD53E553a36CeF67",
      blockCreated: 19258213
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14353601
    }
  }
}), e1 = /* @__PURE__ */ P2({
  id: 11155111,
  name: "Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia.drpc.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://sepolia.etherscan.io",
      apiUrl: "https://api-sepolia.etherscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 751532
    },
    ensRegistry: { address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e" },
    ensUniversalResolver: {
      address: "0xc8Af999e38273D658BE1b921b88A9Ddf005769cC",
      blockCreated: 5317080
    }
  },
  testnet: !0
}), ve = P2({
  ...e1,
  nativeCurrency: {
    ...e1.nativeCurrency,
    symbol: m1.nativeCurrency.symbol
  }
}), Ce = P2({
  ...Q0,
  nativeCurrency: {
    ...Q0.nativeCurrency,
    symbol: g1.nativeCurrency.symbol
  }
});
f0.type = "coinbaseWallet";
function f0(e = {}) {
  return e.version === "3" || e.headlessMode ? Ee(e) : _e(e);
}
function _e(e) {
  let t, i, a, o;
  return g2((s) => ({
    id: "coinbaseWalletSDK",
    name: "Coinbase Wallet",
    rdns: "com.coinbase.wallet",
    type: f0.type,
    async connect({ chainId: f, ...p } = {}) {
      try {
        const d = await this.getProvider(), l = (await d.request({
          method: "eth_requestAccounts",
          params: "instantOnboarding" in p && p.instantOnboarding ? [{ onboarding: "instant" }] : []
        })).map((b) => N(b));
        i || (i = this.onAccountsChanged.bind(this), d.on("accountsChanged", i)), a || (a = this.onChainChanged.bind(this), d.on("chainChanged", a)), o || (o = this.onDisconnect.bind(this), d.on("disconnect", o));
        let u = await this.getChainId();
        return f && u !== f && (u = (await this.switchChain({ chainId: f }).catch((x) => {
          if (x.code === R.code)
            throw x;
          return { id: u };
        }))?.id ?? u), { accounts: l, chainId: u };
      } catch (d) {
        throw /(user closed modal|accounts received is empty|user denied account|request rejected)/i.test(d.message) ? new R(d) : d;
      }
    },
    async disconnect() {
      const f = await this.getProvider();
      i && (f.removeListener("accountsChanged", i), i = void 0), a && (f.removeListener("chainChanged", a), a = void 0), o && (f.removeListener("disconnect", o), o = void 0), f.disconnect(), f.close?.();
    },
    async getAccounts() {
      return (await (await this.getProvider()).request({
        method: "eth_accounts"
      })).map((p) => N(p));
    },
    async getChainId() {
      const p = await (await this.getProvider()).request({
        method: "eth_chainId"
      });
      return Number(p);
    },
    async getProvider() {
      if (!t) {
        const f = typeof e.preference == "string" ? { options: e.preference } : {
          ...e.preference,
          options: e.preference?.options ?? "all"
        }, { createCoinbaseWalletSDK: p } = await import("./index-6fP58c8M.js");
        t = p({
          ...e,
          appChainIds: s.chains.map((l) => l.id),
          preference: f
        }).getProvider();
      }
      return t;
    },
    async isAuthorized() {
      try {
        return !!(await this.getAccounts()).length;
      } catch {
        return !1;
      }
    },
    async switchChain({ addEthereumChainParameter: f, chainId: p }) {
      const d = s.chains.find((u) => u.id === p);
      if (!d)
        throw new s2(new L0());
      const l = await this.getProvider();
      try {
        return await l.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: c2(d.id) }]
        }), d;
      } catch (u) {
        if (u.code === 4902)
          try {
            let b;
            f?.blockExplorerUrls ? b = f.blockExplorerUrls : b = d.blockExplorers?.default.url ? [d.blockExplorers?.default.url] : [];
            let x;
            f?.rpcUrls?.length ? x = f.rpcUrls : x = [d.rpcUrls.default?.http[0] ?? ""];
            const w = {
              blockExplorerUrls: b,
              chainId: c2(p),
              chainName: f?.chainName ?? d.name,
              iconUrls: f?.iconUrls,
              nativeCurrency: f?.nativeCurrency ?? d.nativeCurrency,
              rpcUrls: x
            };
            return await l.request({
              method: "wallet_addEthereumChain",
              params: [w]
            }), d;
          } catch (b) {
            throw new R(b);
          }
        throw new s2(u);
      }
    },
    onAccountsChanged(f) {
      f.length === 0 ? this.onDisconnect() : s.emitter.emit("change", {
        accounts: f.map((p) => N(p))
      });
    },
    onChainChanged(f) {
      const p = Number(f);
      s.emitter.emit("change", { chainId: p });
    },
    async onDisconnect(f) {
      s.emitter.emit("disconnect");
      const p = await this.getProvider();
      i && (p.removeListener("accountsChanged", i), i = void 0), a && (p.removeListener("chainChanged", a), a = void 0), o && (p.removeListener("disconnect", o), o = void 0);
    }
  }));
}
function Ee(e) {
  let i, a, o, s, f;
  return g2((p) => ({
    id: "coinbaseWalletSDK",
    name: "Coinbase Wallet",
    type: f0.type,
    async connect({ chainId: d } = {}) {
      try {
        const l = await this.getProvider(), u = (await l.request({
          method: "eth_requestAccounts"
        })).map((x) => N(x));
        o || (o = this.onAccountsChanged.bind(this), l.on("accountsChanged", o)), s || (s = this.onChainChanged.bind(this), l.on("chainChanged", s)), f || (f = this.onDisconnect.bind(this), l.on("disconnect", f));
        let b = await this.getChainId();
        return d && b !== d && (b = (await this.switchChain({ chainId: d }).catch((w) => {
          if (w.code === R.code)
            throw w;
          return { id: b };
        }))?.id ?? b), { accounts: u, chainId: b };
      } catch (l) {
        throw /(user closed modal|accounts received is empty|user denied account)/i.test(l.message) ? new R(l) : l;
      }
    },
    async disconnect() {
      const d = await this.getProvider();
      o && (d.removeListener("accountsChanged", o), o = void 0), s && (d.removeListener("chainChanged", s), s = void 0), f && (d.removeListener("disconnect", f), f = void 0), d.disconnect(), d.close();
    },
    async getAccounts() {
      return (await (await this.getProvider()).request({
        method: "eth_accounts"
      })).map((l) => N(l));
    },
    async getChainId() {
      const l = await (await this.getProvider()).request({
        method: "eth_chainId"
      });
      return Number(l);
    },
    async getProvider() {
      if (!a) {
        const d = await (async () => {
          const { default: w } = await import("./index-DeL0RyL1.js").then((v) => v.i);
          return typeof w != "function" && typeof w.default == "function" ? w.default : w;
        })();
        i = new d({ ...e, reloadOnDisconnect: !1 });
        const l = i.walletExtension?.getChainId(), u = p.chains.find((w) => e.chainId ? w.id === e.chainId : w.id === l) || p.chains[0], b = e.chainId || u?.id, x = e.jsonRpcUrl || u?.rpcUrls.default.http[0];
        a = i.makeWeb3Provider(x, b);
      }
      return a;
    },
    async isAuthorized() {
      try {
        return !!(await this.getAccounts()).length;
      } catch {
        return !1;
      }
    },
    async switchChain({ addEthereumChainParameter: d, chainId: l }) {
      const u = p.chains.find((x) => x.id === l);
      if (!u)
        throw new s2(new L0());
      const b = await this.getProvider();
      try {
        return await b.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: c2(u.id) }]
        }), u;
      } catch (x) {
        if (x.code === 4902)
          try {
            let w;
            d?.blockExplorerUrls ? w = d.blockExplorerUrls : w = u.blockExplorers?.default.url ? [u.blockExplorers?.default.url] : [];
            let v;
            d?.rpcUrls?.length ? v = d.rpcUrls : v = [u.rpcUrls.default?.http[0] ?? ""];
            const C = {
              blockExplorerUrls: w,
              chainId: c2(l),
              chainName: d?.chainName ?? u.name,
              iconUrls: d?.iconUrls,
              nativeCurrency: d?.nativeCurrency ?? u.nativeCurrency,
              rpcUrls: v
            };
            return await b.request({
              method: "wallet_addEthereumChain",
              params: [C]
            }), u;
          } catch (w) {
            throw new R(w);
          }
        throw new s2(x);
      }
    },
    onAccountsChanged(d) {
      d.length === 0 ? this.onDisconnect() : p.emitter.emit("change", {
        accounts: d.map((l) => N(l))
      });
    },
    onChainChanged(d) {
      const l = Number(d);
      p.emitter.emit("change", { chainId: l });
    },
    async onDisconnect(d) {
      p.emitter.emit("disconnect");
      const l = await this.getProvider();
      o && (l.removeListener("accountsChanged", o), o = void 0), s && (l.removeListener("chainChanged", s), s = void 0), f && (l.removeListener("disconnect", f), f = void 0);
    }
  }));
}
$0.type = "walletConnect";
function $0(e) {
  const t = e.isNewChainsStale ?? !0;
  let i, a;
  const o = "eip155";
  let s, f, p, d, l, u;
  return g2((b) => ({
    id: "walletConnect",
    name: "WalletConnect",
    type: $0.type,
    async setup() {
      const x = await this.getProvider().catch(() => null);
      x && (p || (p = this.onConnect.bind(this), x.on("connect", p)), l || (l = this.onSessionDelete.bind(this), x.on("session_delete", l)));
    },
    async connect({ chainId: x, ...w } = {}) {
      try {
        const v = await this.getProvider();
        if (!v)
          throw new X0();
        d || (d = this.onDisplayUri, v.on("display_uri", d));
        let C = x;
        if (!C) {
          const S = await b.storage?.getItem("state") ?? {};
          b.chains.some((M) => M.id === S.chainId) ? C = S.chainId : C = b.chains[0]?.id;
        }
        if (!C)
          throw new Error("No chains found on connector.");
        const B = await this.isChainsStale();
        if (v.session && B && await v.disconnect(), !v.session || B) {
          const S = b.chains.filter((O) => O.id !== C).map((O) => O.id);
          await v.connect({
            optionalChains: [C, ...S],
            ..."pairingTopic" in w ? { pairingTopic: w.pairingTopic } : {}
          }), this.setRequestedChainsIds(b.chains.map((O) => O.id));
        }
        const F = (await v.enable()).map((S) => N(S)), I = await this.getChainId();
        return d && (v.removeListener("display_uri", d), d = void 0), p && (v.removeListener("connect", p), p = void 0), s || (s = this.onAccountsChanged.bind(this), v.on("accountsChanged", s)), f || (f = this.onChainChanged.bind(this), v.on("chainChanged", f)), u || (u = this.onDisconnect.bind(this), v.on("disconnect", u)), l || (l = this.onSessionDelete.bind(this), v.on("session_delete", l)), { accounts: F, chainId: I };
      } catch (v) {
        throw /(user rejected|connection request reset)/i.test(v?.message) ? new R(v) : v;
      }
    },
    async disconnect() {
      const x = await this.getProvider();
      try {
        await x?.disconnect();
      } catch (w) {
        if (!/No matching key/i.test(w.message))
          throw w;
      } finally {
        f && (x?.removeListener("chainChanged", f), f = void 0), u && (x?.removeListener("disconnect", u), u = void 0), p || (p = this.onConnect.bind(this), x?.on("connect", p)), s && (x?.removeListener("accountsChanged", s), s = void 0), l && (x?.removeListener("session_delete", l), l = void 0), this.setRequestedChainsIds([]);
      }
    },
    async getAccounts() {
      return (await this.getProvider()).accounts.map((w) => N(w));
    },
    async getProvider({ chainId: x } = {}) {
      async function w() {
        const v = b.chains.map((B) => B.id);
        if (!v.length)
          return;
        const { EthereumProvider: C } = await import("./index.es-DMdHMU1M.js");
        return await C.init({
          ...e,
          disableProviderPing: !0,
          optionalChains: v,
          projectId: e.projectId,
          rpcMap: Object.fromEntries(b.chains.map((B) => {
            const [F] = ye({
              chain: B,
              transports: b.transports
            });
            return [B.id, F];
          })),
          showQrModal: e.showQrModal ?? !0
        });
      }
      return i || (a || (a = w()), i = await a, i?.events.setMaxListeners(Number.POSITIVE_INFINITY)), x && await this.switchChain?.({ chainId: x }), i;
    },
    async getChainId() {
      return (await this.getProvider()).chainId;
    },
    async isAuthorized() {
      try {
        const [x, w] = await Promise.all([
          this.getAccounts(),
          this.getProvider()
        ]);
        return x.length ? await this.isChainsStale() && w.session ? (await w.disconnect().catch(() => {
        }), !1) : !0 : !1;
      } catch {
        return !1;
      }
    },
    async switchChain({ addEthereumChainParameter: x, chainId: w }) {
      const v = await this.getProvider();
      if (!v)
        throw new X0();
      const C = b.chains.find((B) => B.id === w);
      if (!C)
        throw new s2(new L0());
      try {
        await Promise.all([
          new Promise((F) => {
            const I = ({ chainId: S }) => {
              S === w && (b.emitter.off("change", I), F());
            };
            b.emitter.on("change", I);
          }),
          v.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: c2(w) }]
          })
        ]);
        const B = await this.getRequestedChainsIds();
        return this.setRequestedChainsIds([...B, w]), C;
      } catch (B) {
        const F = B;
        if (/(user rejected)/i.test(F.message))
          throw new R(F);
        try {
          let I;
          x?.blockExplorerUrls ? I = x.blockExplorerUrls : I = C.blockExplorers?.default.url ? [C.blockExplorers?.default.url] : [];
          let S;
          x?.rpcUrls?.length ? S = x.rpcUrls : S = [...C.rpcUrls.default.http];
          const O = {
            blockExplorerUrls: I,
            chainId: c2(w),
            chainName: x?.chainName ?? C.name,
            iconUrls: x?.iconUrls,
            nativeCurrency: x?.nativeCurrency ?? C.nativeCurrency,
            rpcUrls: S
          };
          await v.request({
            method: "wallet_addEthereumChain",
            params: [O]
          });
          const M = await this.getRequestedChainsIds();
          return this.setRequestedChainsIds([...M, w]), C;
        } catch (I) {
          throw new R(I);
        }
      }
    },
    onAccountsChanged(x) {
      x.length === 0 ? this.onDisconnect() : b.emitter.emit("change", {
        accounts: x.map((w) => N(w))
      });
    },
    onChainChanged(x) {
      const w = Number(x);
      b.emitter.emit("change", { chainId: w });
    },
    async onConnect(x) {
      const w = Number(x.chainId), v = await this.getAccounts();
      b.emitter.emit("connect", { accounts: v, chainId: w });
    },
    async onDisconnect(x) {
      this.setRequestedChainsIds([]), b.emitter.emit("disconnect");
      const w = await this.getProvider();
      s && (w.removeListener("accountsChanged", s), s = void 0), f && (w.removeListener("chainChanged", f), f = void 0), u && (w.removeListener("disconnect", u), u = void 0), l && (w.removeListener("session_delete", l), l = void 0), p || (p = this.onConnect.bind(this), w.on("connect", p));
    },
    onDisplayUri(x) {
      b.emitter.emit("message", { type: "display_uri", data: x });
    },
    onSessionDelete() {
      this.onDisconnect();
    },
    getNamespaceChainsIds() {
      return i ? i.session?.namespaces[o]?.accounts?.map((w) => Number.parseInt(w.split(":")[1] || "")) ?? [] : [];
    },
    async getRequestedChainsIds() {
      return await b.storage?.getItem(this.requestedChainsStorageKey) ?? [];
    },
    /**
     * Checks if the target chains match the chains that were
     * initially requested by the connector for the WalletConnect session.
     * If there is a mismatch, this means that the chains on the connector
     * are considered stale, and need to be revalidated at a later point (via
     * connection).
     *
     * There may be a scenario where a dapp adds a chain to the
     * connector later on, however, this chain will not have been approved or rejected
     * by the wallet. In this case, the chain is considered stale.
     */
    async isChainsStale() {
      if (!t)
        return !1;
      const x = b.chains.map((C) => C.id), w = this.getNamespaceChainsIds();
      if (w.length && !w.some((C) => x.includes(C)))
        return !1;
      const v = await this.getRequestedChainsIds();
      return !x.every((C) => v.includes(C));
    },
    async setRequestedChainsIds(x) {
      await b.storage?.setItem(this.requestedChainsStorageKey, x);
    },
    get requestedChainsStorageKey() {
      return `${this.id}.requestedChains`;
    }
  }));
}
const Be = "data:image/svg+xml,%3csvg%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2040%2040'%3e%3cpath%20d='m37.296%202.348-14.99%2011.134%202.771-6.569%2012.219-4.565Z'%20fill='%23E2761B'%20stroke='%23E2761B'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='m2.69%202.348%2014.87%2011.24-2.637-6.675L2.689%202.348Zm29.212%2025.808-3.992%206.117%208.542%202.35%202.456-8.331-7.006-.136Zm-30.795.136%202.441%208.331%208.542-2.35-3.992-6.117-6.99.136Z'%20fill='%23E4761B'%20stroke='%23E4761B'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='m11.608%2017.821-2.38%203.6%208.482.378-.301-9.115-5.8%205.137Zm16.769%200L22.5%2012.578l-.196%209.22%208.467-.376-2.395-3.6ZM12.09%2034.273l5.093-2.486-4.4-3.435-.693%205.921Zm10.712-2.486%205.108%202.486-.709-5.92-4.399%203.434Z'%20fill='%23E4761B'%20stroke='%23E4761B'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='m27.91%2034.273-5.108-2.486.407%203.33-.045%201.4%204.746-2.244Zm-15.82%200%204.746%202.245-.03-1.401.377-3.33-5.092%202.486Z'%20fill='%23D7C1B3'%20stroke='%23D7C1B3'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='m16.911%2026.152-4.248-1.25%202.998-1.37%201.25%202.62Zm6.162%200%201.25-2.62%203.014%201.37-4.264%201.25Z'%20fill='%23233447'%20stroke='%23233447'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='m12.09%2034.273.723-6.117-4.715.136%203.992%205.981Zm15.096-6.117.724%206.117%203.992-5.981-4.716-.136Zm3.586-6.734-8.467.377.784%204.354%201.25-2.622%203.013%201.371%203.42-3.48Zm-18.11%203.48%203.014-1.37%201.236%202.62.798-4.354-8.482-.376%203.435%203.48Z'%20fill='%23CD6116'%20stroke='%23CD6116'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='m9.228%2021.422%203.556%206.93-.121-3.45-3.435-3.48Zm18.124%203.48-.15%203.45%203.57-6.93-3.42%203.48Zm-9.642-3.104-.799%204.355.995%205.137.226-6.764-.422-2.727Zm4.595%200-.407%202.712.181%206.78%201.01-5.137-.784-4.354Z'%20fill='%23E4751F'%20stroke='%23E4751F'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M23.088%2026.153%2022.08%2031.29l.723.497%204.4-3.435.15-3.45-4.264%201.25Zm-10.425-1.25.12%203.45%204.4%203.434.723-.497-.995-5.137-4.248-1.25Z'%20fill='%23F6851B'%20stroke='%23F6851B'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='m23.164%2036.518.045-1.401-.377-.332h-5.68l-.346.332.03%201.4-4.745-2.244%201.657%201.356%203.36%202.335h5.77l3.374-2.335%201.658-1.356-4.746%202.245Z'%20fill='%23C0AD9E'%20stroke='%23C0AD9E'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='m22.802%2031.787-.723-.497h-4.173l-.723.497-.377%203.33.346-.332h5.68l.377.332-.407-3.33Z'%20fill='%23161616'%20stroke='%23161616'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='m37.928%2014.205%201.281-6.147-1.913-5.71-14.494%2010.758%205.575%204.715%207.88%202.305%201.747-2.034-.753-.542%201.205-1.1-.934-.723%201.205-.92-.798-.602ZM.791%208.058l1.28%206.147-.813.603%201.205.919-.919.723%201.206%201.1-.754.542%201.733%202.034%207.88-2.305%205.574-4.716L2.689%202.348.791%208.058Z'%20fill='%23763D16'%20stroke='%23763D16'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='m36.256%2020.126-7.88-2.305%202.396%203.6-3.57%206.931%204.7-.06h7.006l-2.652-8.166Zm-24.648-2.305-7.88%202.305-2.62%208.166h6.99l4.685.06-3.555-6.93%202.38-3.6Zm10.697%203.977.497-8.692%202.29-6.193h-10.17l2.26%206.192.528%208.694.18%202.742.016%206.749h4.173l.03-6.75.196-2.741Z'%20fill='%23F6851B'%20stroke='%23F6851B'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", Ie = (e) => g2((t) => ({
  ...p1({ ...e, target: "metaMask" })(t),
  imageSrc: Be
})), Ae = "data:image/svg+xml,%3csvg%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2036%2040'%3e%3cg%20clip-path='url(%23a)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M16.672.477a2.053%202.053%200%200%201%202.632%200c5.171%204.319%2011.067%204.286%2013.363%204.273l.316-.001a2.053%202.053%200%200%201%202.052%202.083c-.109%207.213-.398%2012.367-.966%2016.149-.569%203.779-1.442%206.387-2.861%208.36-1.43%201.986-3.266%203.111-5.198%204.18-.336.185-.678.37-1.028.56-1.694.919-3.57%201.936-5.797%203.534a2.052%202.052%200%200%201-2.393%200c-2.226-1.596-4.099-2.613-5.79-3.532-.352-.19-.695-.377-1.032-.563-1.932-1.069-3.766-2.194-5.192-4.182-1.416-1.972-2.287-4.58-2.853-8.358-.566-3.781-.854-8.935-.963-16.148A2.053%202.053%200%200%201%203.015%204.75l.312.001c2.277.013%208.174.046%2013.345-4.273ZM5.105%208.837c.13%206.074.409%2010.385.88%2013.535.525%203.498%201.26%205.364%202.128%206.572.856%201.193%201.98%201.952%203.844%202.983.303.168.622.341.958.523%201.417.768%203.124%201.694%205.073%203%201.952-1.308%203.662-2.234%205.081-3.003.335-.181.653-.354.955-.52%201.865-1.031%202.993-1.791%203.851-2.985.87-1.207%201.608-3.073%202.134-6.572.473-3.149.753-7.459.884-13.532-2.968-.11-8.074-.75-12.905-4.193-4.824%203.44-9.923%204.082-12.883%204.193Z'%20fill='%233375BB'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='a'%3e%3cpath%20fill='%23fff'%20transform='translate(.962)'%20d='M0%200h34.076v40H0z'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Se = (e) => g2((t) => ({
  ...p1({ ...e, target: "trustWallet" })(t),
  imageSrc: Ae
})), Ue = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%201024%201024'%3e%3ccircle%20cx='512'%20cy='512'%20r='512'%20style='fill:%230052ff'/%3e%3cpath%20d='M516.3%20361.83c60.28%200%20108.1%2037.18%20126.26%2092.47H764C742%20336.09%20644.47%20256%20517.27%20256%20372.82%20256%20260%20365.65%20260%20512.49S370%20768%20517.27%20768c124.35%200%20223.82-80.09%20245.84-199.28H642.55c-17.22%2055.3-65%2093.45-125.32%2093.45-83.23%200-141.56-63.89-141.56-149.68.04-86.77%2057.43-150.66%20140.63-150.66z'%20style='fill:%23fff'/%3e%3c/svg%3e", Fe = (e) => g2((t) => ({
  ...f0(e)(t),
  imageSrc: Ue
})), ke = "data:image/svg+xml,%3csvg%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2040%2040'%3e%3cpath%20d='M8.189%2012.535c6.523-6.384%2017.099-6.384%2023.622%200l.785.768a.805.805%200%200%201%200%201.156l-2.685%202.629a.424.424%200%200%201-.59%200L28.24%2016.03c-4.55-4.453-11.93-4.453-16.48%200l-1.157%201.133a.424.424%200%200%201-.59%200l-2.686-2.629a.805.805%200%200%201%200-1.155l.862-.844Zm29.176%205.436%202.39%202.339a.805.805%200%200%201%200%201.156L28.978%2032.013a.848.848%200%200%201-1.181%200l-7.65-7.485a.212.212%200%200%200-.294%200l-7.65%207.485a.848.848%200%200%201-1.18%200L.244%2021.466a.805.805%200%200%201%200-1.156l2.39-2.34a.848.848%200%200%201%201.18%200l7.65%207.486c.082.08.214.08.295%200l7.65-7.485a.848.848%200%200%201%201.18%200l7.65%207.485c.081.08.213.08.295%200l7.65-7.485a.848.848%200%200%201%201.18%200Z'%20fill='%233396FF'/%3e%3c/svg%3e", Pe = (e) => g2((t) => ({
  ...$0(e)(t),
  imageSrc: ke,
  chainSwitchOnlyFromWallet: !0
}));
var D = {}, l0 = {};
l0.byteLength = De;
l0.toByteArray = $e;
l0.fromByteArray = je;
var Q = [], Z = [], Oe = typeof Uint8Array < "u" ? Uint8Array : Array, y0 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var B2 = 0, Re = y0.length; B2 < Re; ++B2)
  Q[B2] = y0[B2], Z[y0.charCodeAt(B2)] = B2;
Z[45] = 62;
Z[95] = 63;
function b1(e) {
  var t = e.length;
  if (t % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var i = e.indexOf("=");
  i === -1 && (i = t);
  var a = i === t ? 0 : 4 - i % 4;
  return [i, a];
}
function De(e) {
  var t = b1(e), i = t[0], a = t[1];
  return (i + a) * 3 / 4 - a;
}
function Le(e, t, i) {
  return (t + i) * 3 / 4 - i;
}
function $e(e) {
  var t, i = b1(e), a = i[0], o = i[1], s = new Oe(Le(e, a, o)), f = 0, p = o > 0 ? a - 4 : a, d;
  for (d = 0; d < p; d += 4)
    t = Z[e.charCodeAt(d)] << 18 | Z[e.charCodeAt(d + 1)] << 12 | Z[e.charCodeAt(d + 2)] << 6 | Z[e.charCodeAt(d + 3)], s[f++] = t >> 16 & 255, s[f++] = t >> 8 & 255, s[f++] = t & 255;
  return o === 2 && (t = Z[e.charCodeAt(d)] << 2 | Z[e.charCodeAt(d + 1)] >> 4, s[f++] = t & 255), o === 1 && (t = Z[e.charCodeAt(d)] << 10 | Z[e.charCodeAt(d + 1)] << 4 | Z[e.charCodeAt(d + 2)] >> 2, s[f++] = t >> 8 & 255, s[f++] = t & 255), s;
}
function Ne(e) {
  return Q[e >> 18 & 63] + Q[e >> 12 & 63] + Q[e >> 6 & 63] + Q[e & 63];
}
function Te(e, t, i) {
  for (var a, o = [], s = t; s < i; s += 3)
    a = (e[s] << 16 & 16711680) + (e[s + 1] << 8 & 65280) + (e[s + 2] & 255), o.push(Ne(a));
  return o.join("");
}
function je(e) {
  for (var t, i = e.length, a = i % 3, o = [], s = 16383, f = 0, p = i - a; f < p; f += s)
    o.push(Te(e, f, f + s > p ? p : f + s));
  return a === 1 ? (t = e[i - 1], o.push(
    Q[t >> 2] + Q[t << 4 & 63] + "=="
  )) : a === 2 && (t = (e[i - 2] << 8) + e[i - 1], o.push(
    Q[t >> 10] + Q[t >> 4 & 63] + Q[t << 2 & 63] + "="
  )), o.join("");
}
var N0 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
N0.read = function(e, t, i, a, o) {
  var s, f, p = o * 8 - a - 1, d = (1 << p) - 1, l = d >> 1, u = -7, b = i ? o - 1 : 0, x = i ? -1 : 1, w = e[t + b];
  for (b += x, s = w & (1 << -u) - 1, w >>= -u, u += p; u > 0; s = s * 256 + e[t + b], b += x, u -= 8)
    ;
  for (f = s & (1 << -u) - 1, s >>= -u, u += a; u > 0; f = f * 256 + e[t + b], b += x, u -= 8)
    ;
  if (s === 0)
    s = 1 - l;
  else {
    if (s === d)
      return f ? NaN : (w ? -1 : 1) * (1 / 0);
    f = f + Math.pow(2, a), s = s - l;
  }
  return (w ? -1 : 1) * f * Math.pow(2, s - a);
};
N0.write = function(e, t, i, a, o, s) {
  var f, p, d, l = s * 8 - o - 1, u = (1 << l) - 1, b = u >> 1, x = o === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, w = a ? 0 : s - 1, v = a ? 1 : -1, C = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (p = isNaN(t) ? 1 : 0, f = u) : (f = Math.floor(Math.log(t) / Math.LN2), t * (d = Math.pow(2, -f)) < 1 && (f--, d *= 2), f + b >= 1 ? t += x / d : t += x * Math.pow(2, 1 - b), t * d >= 2 && (f++, d /= 2), f + b >= u ? (p = 0, f = u) : f + b >= 1 ? (p = (t * d - 1) * Math.pow(2, o), f = f + b) : (p = t * Math.pow(2, b - 1) * Math.pow(2, o), f = 0)); o >= 8; e[i + w] = p & 255, w += v, p /= 256, o -= 8)
    ;
  for (f = f << o | p, l += o; l > 0; e[i + w] = f & 255, w += v, f /= 256, l -= 8)
    ;
  e[i + w - v] |= C * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(e) {
  const t = l0, i = N0, a = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  e.Buffer = u, e.SlowBuffer = M, e.INSPECT_MAX_BYTES = 50;
  const o = 2147483647;
  e.kMaxLength = o;
  const { Uint8Array: s, ArrayBuffer: f, SharedArrayBuffer: p } = globalThis;
  u.TYPED_ARRAY_SUPPORT = d(), !u.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function d() {
    try {
      const c = new s(1), r = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(r, s.prototype), Object.setPrototypeOf(c, r), c.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(u.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (u.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(u.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (u.isBuffer(this))
        return this.byteOffset;
    }
  });
  function l(c) {
    if (c > o)
      throw new RangeError('The value "' + c + '" is invalid for option "size"');
    const r = new s(c);
    return Object.setPrototypeOf(r, u.prototype), r;
  }
  function u(c, r, n) {
    if (typeof c == "number") {
      if (typeof r == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return v(c);
    }
    return b(c, r, n);
  }
  u.poolSize = 8192;
  function b(c, r, n) {
    if (typeof c == "string")
      return C(c, r);
    if (f.isView(c))
      return F(c);
    if (c == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof c
      );
    if (J(c, f) || c && J(c.buffer, f) || typeof p < "u" && (J(c, p) || c && J(c.buffer, p)))
      return I(c, r, n);
    if (typeof c == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const h = c.valueOf && c.valueOf();
    if (h != null && h !== c)
      return u.from(h, r, n);
    const g = S(c);
    if (g) return g;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof c[Symbol.toPrimitive] == "function")
      return u.from(c[Symbol.toPrimitive]("string"), r, n);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof c
    );
  }
  u.from = function(c, r, n) {
    return b(c, r, n);
  }, Object.setPrototypeOf(u.prototype, s.prototype), Object.setPrototypeOf(u, s);
  function x(c) {
    if (typeof c != "number")
      throw new TypeError('"size" argument must be of type number');
    if (c < 0)
      throw new RangeError('The value "' + c + '" is invalid for option "size"');
  }
  function w(c, r, n) {
    return x(c), c <= 0 ? l(c) : r !== void 0 ? typeof n == "string" ? l(c).fill(r, n) : l(c).fill(r) : l(c);
  }
  u.alloc = function(c, r, n) {
    return w(c, r, n);
  };
  function v(c) {
    return x(c), l(c < 0 ? 0 : O(c) | 0);
  }
  u.allocUnsafe = function(c) {
    return v(c);
  }, u.allocUnsafeSlow = function(c) {
    return v(c);
  };
  function C(c, r) {
    if ((typeof r != "string" || r === "") && (r = "utf8"), !u.isEncoding(r))
      throw new TypeError("Unknown encoding: " + r);
    const n = f2(c, r) | 0;
    let h = l(n);
    const g = h.write(c, r);
    return g !== n && (h = h.slice(0, g)), h;
  }
  function B(c) {
    const r = c.length < 0 ? 0 : O(c.length) | 0, n = l(r);
    for (let h = 0; h < r; h += 1)
      n[h] = c[h] & 255;
    return n;
  }
  function F(c) {
    if (J(c, s)) {
      const r = new s(c);
      return I(r.buffer, r.byteOffset, r.byteLength);
    }
    return B(c);
  }
  function I(c, r, n) {
    if (r < 0 || c.byteLength < r)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (c.byteLength < r + (n || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let h;
    return r === void 0 && n === void 0 ? h = new s(c) : n === void 0 ? h = new s(c, r) : h = new s(c, r, n), Object.setPrototypeOf(h, u.prototype), h;
  }
  function S(c) {
    if (u.isBuffer(c)) {
      const r = O(c.length) | 0, n = l(r);
      return n.length === 0 || c.copy(n, 0, 0, r), n;
    }
    if (c.length !== void 0)
      return typeof c.length != "number" || x0(c.length) ? l(0) : B(c);
    if (c.type === "Buffer" && Array.isArray(c.data))
      return B(c.data);
  }
  function O(c) {
    if (c >= o)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + o.toString(16) + " bytes");
    return c | 0;
  }
  function M(c) {
    return +c != c && (c = 0), u.alloc(+c);
  }
  u.isBuffer = function(r) {
    return r != null && r._isBuffer === !0 && r !== u.prototype;
  }, u.compare = function(r, n) {
    if (J(r, s) && (r = u.from(r, r.offset, r.byteLength)), J(n, s) && (n = u.from(n, n.offset, n.byteLength)), !u.isBuffer(r) || !u.isBuffer(n))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (r === n) return 0;
    let h = r.length, g = n.length;
    for (let m = 0, y = Math.min(h, g); m < y; ++m)
      if (r[m] !== n[m]) {
        h = r[m], g = n[m];
        break;
      }
    return h < g ? -1 : g < h ? 1 : 0;
  }, u.isEncoding = function(r) {
    switch (String(r).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, u.concat = function(r, n) {
    if (!Array.isArray(r))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (r.length === 0)
      return u.alloc(0);
    let h;
    if (n === void 0)
      for (n = 0, h = 0; h < r.length; ++h)
        n += r[h].length;
    const g = u.allocUnsafe(n);
    let m = 0;
    for (h = 0; h < r.length; ++h) {
      let y = r[h];
      if (J(y, s))
        m + y.length > g.length ? (u.isBuffer(y) || (y = u.from(y)), y.copy(g, m)) : s.prototype.set.call(
          g,
          y,
          m
        );
      else if (u.isBuffer(y))
        y.copy(g, m);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      m += y.length;
    }
    return g;
  };
  function f2(c, r) {
    if (u.isBuffer(c))
      return c.length;
    if (f.isView(c) || J(c, f))
      return c.byteLength;
    if (typeof c != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof c
      );
    const n = c.length, h = arguments.length > 2 && arguments[2] === !0;
    if (!h && n === 0) return 0;
    let g = !1;
    for (; ; )
      switch (r) {
        case "ascii":
        case "latin1":
        case "binary":
          return n;
        case "utf8":
        case "utf-8":
          return b0(c).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return n * 2;
        case "hex":
          return n >>> 1;
        case "base64":
          return Y0(c).length;
        default:
          if (g)
            return h ? -1 : b0(c).length;
          r = ("" + r).toLowerCase(), g = !0;
      }
  }
  u.byteLength = f2;
  function m2(c, r, n) {
    let h = !1;
    if ((r === void 0 || r < 0) && (r = 0), r > this.length || ((n === void 0 || n > this.length) && (n = this.length), n <= 0) || (n >>>= 0, r >>>= 0, n <= r))
      return "";
    for (c || (c = "utf8"); ; )
      switch (c) {
        case "hex":
          return ne(this, r, n);
        case "utf8":
        case "utf-8":
          return T2(this, r, n);
        case "ascii":
          return te(this, r, n);
        case "latin1":
        case "binary":
          return re(this, r, n);
        case "base64":
          return C2(this, r, n);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ie(this, r, n);
        default:
          if (h) throw new TypeError("Unknown encoding: " + c);
          c = (c + "").toLowerCase(), h = !0;
      }
  }
  u.prototype._isBuffer = !0;
  function q(c, r, n) {
    const h = c[r];
    c[r] = c[n], c[n] = h;
  }
  u.prototype.swap16 = function() {
    const r = this.length;
    if (r % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let n = 0; n < r; n += 2)
      q(this, n, n + 1);
    return this;
  }, u.prototype.swap32 = function() {
    const r = this.length;
    if (r % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let n = 0; n < r; n += 4)
      q(this, n, n + 3), q(this, n + 1, n + 2);
    return this;
  }, u.prototype.swap64 = function() {
    const r = this.length;
    if (r % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let n = 0; n < r; n += 8)
      q(this, n, n + 7), q(this, n + 1, n + 6), q(this, n + 2, n + 5), q(this, n + 3, n + 4);
    return this;
  }, u.prototype.toString = function() {
    const r = this.length;
    return r === 0 ? "" : arguments.length === 0 ? T2(this, 0, r) : m2.apply(this, arguments);
  }, u.prototype.toLocaleString = u.prototype.toString, u.prototype.equals = function(r) {
    if (!u.isBuffer(r)) throw new TypeError("Argument must be a Buffer");
    return this === r ? !0 : u.compare(this, r) === 0;
  }, u.prototype.inspect = function() {
    let r = "";
    const n = e.INSPECT_MAX_BYTES;
    return r = this.toString("hex", 0, n).replace(/(.{2})/g, "$1 ").trim(), this.length > n && (r += " ... "), "<Buffer " + r + ">";
  }, a && (u.prototype[a] = u.prototype.inspect), u.prototype.compare = function(r, n, h, g, m) {
    if (J(r, s) && (r = u.from(r, r.offset, r.byteLength)), !u.isBuffer(r))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof r
      );
    if (n === void 0 && (n = 0), h === void 0 && (h = r ? r.length : 0), g === void 0 && (g = 0), m === void 0 && (m = this.length), n < 0 || h > r.length || g < 0 || m > this.length)
      throw new RangeError("out of range index");
    if (g >= m && n >= h)
      return 0;
    if (g >= m)
      return -1;
    if (n >= h)
      return 1;
    if (n >>>= 0, h >>>= 0, g >>>= 0, m >>>= 0, this === r) return 0;
    let y = m - g, _ = h - n;
    const k = Math.min(y, _), U = this.slice(g, m), P = r.slice(n, h);
    for (let A = 0; A < k; ++A)
      if (U[A] !== P[A]) {
        y = U[A], _ = P[A];
        break;
      }
    return y < _ ? -1 : _ < y ? 1 : 0;
  };
  function $2(c, r, n, h, g) {
    if (c.length === 0) return -1;
    if (typeof n == "string" ? (h = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, x0(n) && (n = g ? 0 : c.length - 1), n < 0 && (n = c.length + n), n >= c.length) {
      if (g) return -1;
      n = c.length - 1;
    } else if (n < 0)
      if (g) n = 0;
      else return -1;
    if (typeof r == "string" && (r = u.from(r, h)), u.isBuffer(r))
      return r.length === 0 ? -1 : N2(c, r, n, h, g);
    if (typeof r == "number")
      return r = r & 255, typeof s.prototype.indexOf == "function" ? g ? s.prototype.indexOf.call(c, r, n) : s.prototype.lastIndexOf.call(c, r, n) : N2(c, [r], n, h, g);
    throw new TypeError("val must be string, number or Buffer");
  }
  function N2(c, r, n, h, g) {
    let m = 1, y = c.length, _ = r.length;
    if (h !== void 0 && (h = String(h).toLowerCase(), h === "ucs2" || h === "ucs-2" || h === "utf16le" || h === "utf-16le")) {
      if (c.length < 2 || r.length < 2)
        return -1;
      m = 2, y /= 2, _ /= 2, n /= 2;
    }
    function k(P, A) {
      return m === 1 ? P[A] : P.readUInt16BE(A * m);
    }
    let U;
    if (g) {
      let P = -1;
      for (U = n; U < y; U++)
        if (k(c, U) === k(r, P === -1 ? 0 : U - P)) {
          if (P === -1 && (P = U), U - P + 1 === _) return P * m;
        } else
          P !== -1 && (U -= U - P), P = -1;
    } else
      for (n + _ > y && (n = y - _), U = n; U >= 0; U--) {
        let P = !0;
        for (let A = 0; A < _; A++)
          if (k(c, U + A) !== k(r, A)) {
            P = !1;
            break;
          }
        if (P) return U;
      }
    return -1;
  }
  u.prototype.includes = function(r, n, h) {
    return this.indexOf(r, n, h) !== -1;
  }, u.prototype.indexOf = function(r, n, h) {
    return $2(this, r, n, h, !0);
  }, u.prototype.lastIndexOf = function(r, n, h) {
    return $2(this, r, n, h, !1);
  };
  function X2(c, r, n, h) {
    n = Number(n) || 0;
    const g = c.length - n;
    h ? (h = Number(h), h > g && (h = g)) : h = g;
    const m = r.length;
    h > m / 2 && (h = m / 2);
    let y;
    for (y = 0; y < h; ++y) {
      const _ = parseInt(r.substr(y * 2, 2), 16);
      if (x0(_)) return y;
      c[n + y] = _;
    }
    return y;
  }
  function Q2(c, r, n, h) {
    return r0(b0(r, c.length - n), c, n, h);
  }
  function e0(c, r, n, h) {
    return r0(ce(r), c, n, h);
  }
  function t0(c, r, n, h) {
    return r0(Y0(r), c, n, h);
  }
  function v2(c, r, n, h) {
    return r0(ue(r, c.length - n), c, n, h);
  }
  u.prototype.write = function(r, n, h, g) {
    if (n === void 0)
      g = "utf8", h = this.length, n = 0;
    else if (h === void 0 && typeof n == "string")
      g = n, h = this.length, n = 0;
    else if (isFinite(n))
      n = n >>> 0, isFinite(h) ? (h = h >>> 0, g === void 0 && (g = "utf8")) : (g = h, h = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const m = this.length - n;
    if ((h === void 0 || h > m) && (h = m), r.length > 0 && (h < 0 || n < 0) || n > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    g || (g = "utf8");
    let y = !1;
    for (; ; )
      switch (g) {
        case "hex":
          return X2(this, r, n, h);
        case "utf8":
        case "utf-8":
          return Q2(this, r, n, h);
        case "ascii":
        case "latin1":
        case "binary":
          return e0(this, r, n, h);
        case "base64":
          return t0(this, r, n, h);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return v2(this, r, n, h);
        default:
          if (y) throw new TypeError("Unknown encoding: " + g);
          g = ("" + g).toLowerCase(), y = !0;
      }
  }, u.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function C2(c, r, n) {
    return r === 0 && n === c.length ? t.fromByteArray(c) : t.fromByteArray(c.slice(r, n));
  }
  function T2(c, r, n) {
    n = Math.min(c.length, n);
    const h = [];
    let g = r;
    for (; g < n; ) {
      const m = c[g];
      let y = null, _ = m > 239 ? 4 : m > 223 ? 3 : m > 191 ? 2 : 1;
      if (g + _ <= n) {
        let k, U, P, A;
        switch (_) {
          case 1:
            m < 128 && (y = m);
            break;
          case 2:
            k = c[g + 1], (k & 192) === 128 && (A = (m & 31) << 6 | k & 63, A > 127 && (y = A));
            break;
          case 3:
            k = c[g + 1], U = c[g + 2], (k & 192) === 128 && (U & 192) === 128 && (A = (m & 15) << 12 | (k & 63) << 6 | U & 63, A > 2047 && (A < 55296 || A > 57343) && (y = A));
            break;
          case 4:
            k = c[g + 1], U = c[g + 2], P = c[g + 3], (k & 192) === 128 && (U & 192) === 128 && (P & 192) === 128 && (A = (m & 15) << 18 | (k & 63) << 12 | (U & 63) << 6 | P & 63, A > 65535 && A < 1114112 && (y = A));
        }
      }
      y === null ? (y = 65533, _ = 1) : y > 65535 && (y -= 65536, h.push(y >>> 10 & 1023 | 55296), y = 56320 | y & 1023), h.push(y), g += _;
    }
    return ee(h);
  }
  const j2 = 4096;
  function ee(c) {
    const r = c.length;
    if (r <= j2)
      return String.fromCharCode.apply(String, c);
    let n = "", h = 0;
    for (; h < r; )
      n += String.fromCharCode.apply(
        String,
        c.slice(h, h += j2)
      );
    return n;
  }
  function te(c, r, n) {
    let h = "";
    n = Math.min(c.length, n);
    for (let g = r; g < n; ++g)
      h += String.fromCharCode(c[g] & 127);
    return h;
  }
  function re(c, r, n) {
    let h = "";
    n = Math.min(c.length, n);
    for (let g = r; g < n; ++g)
      h += String.fromCharCode(c[g]);
    return h;
  }
  function ne(c, r, n) {
    const h = c.length;
    (!r || r < 0) && (r = 0), (!n || n < 0 || n > h) && (n = h);
    let g = "";
    for (let m = r; m < n; ++m)
      g += he[c[m]];
    return g;
  }
  function ie(c, r, n) {
    const h = c.slice(r, n);
    let g = "";
    for (let m = 0; m < h.length - 1; m += 2)
      g += String.fromCharCode(h[m] + h[m + 1] * 256);
    return g;
  }
  u.prototype.slice = function(r, n) {
    const h = this.length;
    r = ~~r, n = n === void 0 ? h : ~~n, r < 0 ? (r += h, r < 0 && (r = 0)) : r > h && (r = h), n < 0 ? (n += h, n < 0 && (n = 0)) : n > h && (n = h), n < r && (n = r);
    const g = this.subarray(r, n);
    return Object.setPrototypeOf(g, u.prototype), g;
  };
  function L(c, r, n) {
    if (c % 1 !== 0 || c < 0) throw new RangeError("offset is not uint");
    if (c + r > n) throw new RangeError("Trying to access beyond buffer length");
  }
  u.prototype.readUintLE = u.prototype.readUIntLE = function(r, n, h) {
    r = r >>> 0, n = n >>> 0, h || L(r, n, this.length);
    let g = this[r], m = 1, y = 0;
    for (; ++y < n && (m *= 256); )
      g += this[r + y] * m;
    return g;
  }, u.prototype.readUintBE = u.prototype.readUIntBE = function(r, n, h) {
    r = r >>> 0, n = n >>> 0, h || L(r, n, this.length);
    let g = this[r + --n], m = 1;
    for (; n > 0 && (m *= 256); )
      g += this[r + --n] * m;
    return g;
  }, u.prototype.readUint8 = u.prototype.readUInt8 = function(r, n) {
    return r = r >>> 0, n || L(r, 1, this.length), this[r];
  }, u.prototype.readUint16LE = u.prototype.readUInt16LE = function(r, n) {
    return r = r >>> 0, n || L(r, 2, this.length), this[r] | this[r + 1] << 8;
  }, u.prototype.readUint16BE = u.prototype.readUInt16BE = function(r, n) {
    return r = r >>> 0, n || L(r, 2, this.length), this[r] << 8 | this[r + 1];
  }, u.prototype.readUint32LE = u.prototype.readUInt32LE = function(r, n) {
    return r = r >>> 0, n || L(r, 4, this.length), (this[r] | this[r + 1] << 8 | this[r + 2] << 16) + this[r + 3] * 16777216;
  }, u.prototype.readUint32BE = u.prototype.readUInt32BE = function(r, n) {
    return r = r >>> 0, n || L(r, 4, this.length), this[r] * 16777216 + (this[r + 1] << 16 | this[r + 2] << 8 | this[r + 3]);
  }, u.prototype.readBigUInt64LE = l2(function(r) {
    r = r >>> 0, E2(r, "offset");
    const n = this[r], h = this[r + 7];
    (n === void 0 || h === void 0) && M2(r, this.length - 8);
    const g = n + this[++r] * 2 ** 8 + this[++r] * 2 ** 16 + this[++r] * 2 ** 24, m = this[++r] + this[++r] * 2 ** 8 + this[++r] * 2 ** 16 + h * 2 ** 24;
    return BigInt(g) + (BigInt(m) << BigInt(32));
  }), u.prototype.readBigUInt64BE = l2(function(r) {
    r = r >>> 0, E2(r, "offset");
    const n = this[r], h = this[r + 7];
    (n === void 0 || h === void 0) && M2(r, this.length - 8);
    const g = n * 2 ** 24 + this[++r] * 2 ** 16 + this[++r] * 2 ** 8 + this[++r], m = this[++r] * 2 ** 24 + this[++r] * 2 ** 16 + this[++r] * 2 ** 8 + h;
    return (BigInt(g) << BigInt(32)) + BigInt(m);
  }), u.prototype.readIntLE = function(r, n, h) {
    r = r >>> 0, n = n >>> 0, h || L(r, n, this.length);
    let g = this[r], m = 1, y = 0;
    for (; ++y < n && (m *= 256); )
      g += this[r + y] * m;
    return m *= 128, g >= m && (g -= Math.pow(2, 8 * n)), g;
  }, u.prototype.readIntBE = function(r, n, h) {
    r = r >>> 0, n = n >>> 0, h || L(r, n, this.length);
    let g = n, m = 1, y = this[r + --g];
    for (; g > 0 && (m *= 256); )
      y += this[r + --g] * m;
    return m *= 128, y >= m && (y -= Math.pow(2, 8 * n)), y;
  }, u.prototype.readInt8 = function(r, n) {
    return r = r >>> 0, n || L(r, 1, this.length), this[r] & 128 ? (255 - this[r] + 1) * -1 : this[r];
  }, u.prototype.readInt16LE = function(r, n) {
    r = r >>> 0, n || L(r, 2, this.length);
    const h = this[r] | this[r + 1] << 8;
    return h & 32768 ? h | 4294901760 : h;
  }, u.prototype.readInt16BE = function(r, n) {
    r = r >>> 0, n || L(r, 2, this.length);
    const h = this[r + 1] | this[r] << 8;
    return h & 32768 ? h | 4294901760 : h;
  }, u.prototype.readInt32LE = function(r, n) {
    return r = r >>> 0, n || L(r, 4, this.length), this[r] | this[r + 1] << 8 | this[r + 2] << 16 | this[r + 3] << 24;
  }, u.prototype.readInt32BE = function(r, n) {
    return r = r >>> 0, n || L(r, 4, this.length), this[r] << 24 | this[r + 1] << 16 | this[r + 2] << 8 | this[r + 3];
  }, u.prototype.readBigInt64LE = l2(function(r) {
    r = r >>> 0, E2(r, "offset");
    const n = this[r], h = this[r + 7];
    (n === void 0 || h === void 0) && M2(r, this.length - 8);
    const g = this[r + 4] + this[r + 5] * 2 ** 8 + this[r + 6] * 2 ** 16 + (h << 24);
    return (BigInt(g) << BigInt(32)) + BigInt(n + this[++r] * 2 ** 8 + this[++r] * 2 ** 16 + this[++r] * 2 ** 24);
  }), u.prototype.readBigInt64BE = l2(function(r) {
    r = r >>> 0, E2(r, "offset");
    const n = this[r], h = this[r + 7];
    (n === void 0 || h === void 0) && M2(r, this.length - 8);
    const g = (n << 24) + // Overflow
    this[++r] * 2 ** 16 + this[++r] * 2 ** 8 + this[++r];
    return (BigInt(g) << BigInt(32)) + BigInt(this[++r] * 2 ** 24 + this[++r] * 2 ** 16 + this[++r] * 2 ** 8 + h);
  }), u.prototype.readFloatLE = function(r, n) {
    return r = r >>> 0, n || L(r, 4, this.length), i.read(this, r, !0, 23, 4);
  }, u.prototype.readFloatBE = function(r, n) {
    return r = r >>> 0, n || L(r, 4, this.length), i.read(this, r, !1, 23, 4);
  }, u.prototype.readDoubleLE = function(r, n) {
    return r = r >>> 0, n || L(r, 8, this.length), i.read(this, r, !0, 52, 8);
  }, u.prototype.readDoubleBE = function(r, n) {
    return r = r >>> 0, n || L(r, 8, this.length), i.read(this, r, !1, 52, 8);
  };
  function T(c, r, n, h, g, m) {
    if (!u.isBuffer(c)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (r > g || r < m) throw new RangeError('"value" argument is out of bounds');
    if (n + h > c.length) throw new RangeError("Index out of range");
  }
  u.prototype.writeUintLE = u.prototype.writeUIntLE = function(r, n, h, g) {
    if (r = +r, n = n >>> 0, h = h >>> 0, !g) {
      const _ = Math.pow(2, 8 * h) - 1;
      T(this, r, n, h, _, 0);
    }
    let m = 1, y = 0;
    for (this[n] = r & 255; ++y < h && (m *= 256); )
      this[n + y] = r / m & 255;
    return n + h;
  }, u.prototype.writeUintBE = u.prototype.writeUIntBE = function(r, n, h, g) {
    if (r = +r, n = n >>> 0, h = h >>> 0, !g) {
      const _ = Math.pow(2, 8 * h) - 1;
      T(this, r, n, h, _, 0);
    }
    let m = h - 1, y = 1;
    for (this[n + m] = r & 255; --m >= 0 && (y *= 256); )
      this[n + m] = r / y & 255;
    return n + h;
  }, u.prototype.writeUint8 = u.prototype.writeUInt8 = function(r, n, h) {
    return r = +r, n = n >>> 0, h || T(this, r, n, 1, 255, 0), this[n] = r & 255, n + 1;
  }, u.prototype.writeUint16LE = u.prototype.writeUInt16LE = function(r, n, h) {
    return r = +r, n = n >>> 0, h || T(this, r, n, 2, 65535, 0), this[n] = r & 255, this[n + 1] = r >>> 8, n + 2;
  }, u.prototype.writeUint16BE = u.prototype.writeUInt16BE = function(r, n, h) {
    return r = +r, n = n >>> 0, h || T(this, r, n, 2, 65535, 0), this[n] = r >>> 8, this[n + 1] = r & 255, n + 2;
  }, u.prototype.writeUint32LE = u.prototype.writeUInt32LE = function(r, n, h) {
    return r = +r, n = n >>> 0, h || T(this, r, n, 4, 4294967295, 0), this[n + 3] = r >>> 24, this[n + 2] = r >>> 16, this[n + 1] = r >>> 8, this[n] = r & 255, n + 4;
  }, u.prototype.writeUint32BE = u.prototype.writeUInt32BE = function(r, n, h) {
    return r = +r, n = n >>> 0, h || T(this, r, n, 4, 4294967295, 0), this[n] = r >>> 24, this[n + 1] = r >>> 16, this[n + 2] = r >>> 8, this[n + 3] = r & 255, n + 4;
  };
  function z0(c, r, n, h, g) {
    J0(r, h, g, c, n, 7);
    let m = Number(r & BigInt(4294967295));
    c[n++] = m, m = m >> 8, c[n++] = m, m = m >> 8, c[n++] = m, m = m >> 8, c[n++] = m;
    let y = Number(r >> BigInt(32) & BigInt(4294967295));
    return c[n++] = y, y = y >> 8, c[n++] = y, y = y >> 8, c[n++] = y, y = y >> 8, c[n++] = y, n;
  }
  function Z0(c, r, n, h, g) {
    J0(r, h, g, c, n, 7);
    let m = Number(r & BigInt(4294967295));
    c[n + 7] = m, m = m >> 8, c[n + 6] = m, m = m >> 8, c[n + 5] = m, m = m >> 8, c[n + 4] = m;
    let y = Number(r >> BigInt(32) & BigInt(4294967295));
    return c[n + 3] = y, y = y >> 8, c[n + 2] = y, y = y >> 8, c[n + 1] = y, y = y >> 8, c[n] = y, n + 8;
  }
  u.prototype.writeBigUInt64LE = l2(function(r, n = 0) {
    return z0(this, r, n, BigInt(0), BigInt("0xffffffffffffffff"));
  }), u.prototype.writeBigUInt64BE = l2(function(r, n = 0) {
    return Z0(this, r, n, BigInt(0), BigInt("0xffffffffffffffff"));
  }), u.prototype.writeIntLE = function(r, n, h, g) {
    if (r = +r, n = n >>> 0, !g) {
      const k = Math.pow(2, 8 * h - 1);
      T(this, r, n, h, k - 1, -k);
    }
    let m = 0, y = 1, _ = 0;
    for (this[n] = r & 255; ++m < h && (y *= 256); )
      r < 0 && _ === 0 && this[n + m - 1] !== 0 && (_ = 1), this[n + m] = (r / y >> 0) - _ & 255;
    return n + h;
  }, u.prototype.writeIntBE = function(r, n, h, g) {
    if (r = +r, n = n >>> 0, !g) {
      const k = Math.pow(2, 8 * h - 1);
      T(this, r, n, h, k - 1, -k);
    }
    let m = h - 1, y = 1, _ = 0;
    for (this[n + m] = r & 255; --m >= 0 && (y *= 256); )
      r < 0 && _ === 0 && this[n + m + 1] !== 0 && (_ = 1), this[n + m] = (r / y >> 0) - _ & 255;
    return n + h;
  }, u.prototype.writeInt8 = function(r, n, h) {
    return r = +r, n = n >>> 0, h || T(this, r, n, 1, 127, -128), r < 0 && (r = 255 + r + 1), this[n] = r & 255, n + 1;
  }, u.prototype.writeInt16LE = function(r, n, h) {
    return r = +r, n = n >>> 0, h || T(this, r, n, 2, 32767, -32768), this[n] = r & 255, this[n + 1] = r >>> 8, n + 2;
  }, u.prototype.writeInt16BE = function(r, n, h) {
    return r = +r, n = n >>> 0, h || T(this, r, n, 2, 32767, -32768), this[n] = r >>> 8, this[n + 1] = r & 255, n + 2;
  }, u.prototype.writeInt32LE = function(r, n, h) {
    return r = +r, n = n >>> 0, h || T(this, r, n, 4, 2147483647, -2147483648), this[n] = r & 255, this[n + 1] = r >>> 8, this[n + 2] = r >>> 16, this[n + 3] = r >>> 24, n + 4;
  }, u.prototype.writeInt32BE = function(r, n, h) {
    return r = +r, n = n >>> 0, h || T(this, r, n, 4, 2147483647, -2147483648), r < 0 && (r = 4294967295 + r + 1), this[n] = r >>> 24, this[n + 1] = r >>> 16, this[n + 2] = r >>> 8, this[n + 3] = r & 255, n + 4;
  }, u.prototype.writeBigInt64LE = l2(function(r, n = 0) {
    return z0(this, r, n, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), u.prototype.writeBigInt64BE = l2(function(r, n = 0) {
    return Z0(this, r, n, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function H0(c, r, n, h, g, m) {
    if (n + h > c.length) throw new RangeError("Index out of range");
    if (n < 0) throw new RangeError("Index out of range");
  }
  function K0(c, r, n, h, g) {
    return r = +r, n = n >>> 0, g || H0(c, r, n, 4), i.write(c, r, n, h, 23, 4), n + 4;
  }
  u.prototype.writeFloatLE = function(r, n, h) {
    return K0(this, r, n, !0, h);
  }, u.prototype.writeFloatBE = function(r, n, h) {
    return K0(this, r, n, !1, h);
  };
  function G0(c, r, n, h, g) {
    return r = +r, n = n >>> 0, g || H0(c, r, n, 8), i.write(c, r, n, h, 52, 8), n + 8;
  }
  u.prototype.writeDoubleLE = function(r, n, h) {
    return G0(this, r, n, !0, h);
  }, u.prototype.writeDoubleBE = function(r, n, h) {
    return G0(this, r, n, !1, h);
  }, u.prototype.copy = function(r, n, h, g) {
    if (!u.isBuffer(r)) throw new TypeError("argument should be a Buffer");
    if (h || (h = 0), !g && g !== 0 && (g = this.length), n >= r.length && (n = r.length), n || (n = 0), g > 0 && g < h && (g = h), g === h || r.length === 0 || this.length === 0) return 0;
    if (n < 0)
      throw new RangeError("targetStart out of bounds");
    if (h < 0 || h >= this.length) throw new RangeError("Index out of range");
    if (g < 0) throw new RangeError("sourceEnd out of bounds");
    g > this.length && (g = this.length), r.length - n < g - h && (g = r.length - n + h);
    const m = g - h;
    return this === r && typeof s.prototype.copyWithin == "function" ? this.copyWithin(n, h, g) : s.prototype.set.call(
      r,
      this.subarray(h, g),
      n
    ), m;
  }, u.prototype.fill = function(r, n, h, g) {
    if (typeof r == "string") {
      if (typeof n == "string" ? (g = n, n = 0, h = this.length) : typeof h == "string" && (g = h, h = this.length), g !== void 0 && typeof g != "string")
        throw new TypeError("encoding must be a string");
      if (typeof g == "string" && !u.isEncoding(g))
        throw new TypeError("Unknown encoding: " + g);
      if (r.length === 1) {
        const y = r.charCodeAt(0);
        (g === "utf8" && y < 128 || g === "latin1") && (r = y);
      }
    } else typeof r == "number" ? r = r & 255 : typeof r == "boolean" && (r = Number(r));
    if (n < 0 || this.length < n || this.length < h)
      throw new RangeError("Out of range index");
    if (h <= n)
      return this;
    n = n >>> 0, h = h === void 0 ? this.length : h >>> 0, r || (r = 0);
    let m;
    if (typeof r == "number")
      for (m = n; m < h; ++m)
        this[m] = r;
    else {
      const y = u.isBuffer(r) ? r : u.from(r, g), _ = y.length;
      if (_ === 0)
        throw new TypeError('The value "' + r + '" is invalid for argument "value"');
      for (m = 0; m < h - n; ++m)
        this[m + n] = y[m % _];
    }
    return this;
  };
  const _2 = {};
  function m0(c, r, n) {
    _2[c] = class extends n {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: r.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${c}]`, this.stack, delete this.name;
      }
      get code() {
        return c;
      }
      set code(g) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: g,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${c}]: ${this.message}`;
      }
    };
  }
  m0(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(c) {
      return c ? `${c} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), m0(
    "ERR_INVALID_ARG_TYPE",
    function(c, r) {
      return `The "${c}" argument must be of type number. Received type ${typeof r}`;
    },
    TypeError
  ), m0(
    "ERR_OUT_OF_RANGE",
    function(c, r, n) {
      let h = `The value of "${c}" is out of range.`, g = n;
      return Number.isInteger(n) && Math.abs(n) > 2 ** 32 ? g = V0(String(n)) : typeof n == "bigint" && (g = String(n), (n > BigInt(2) ** BigInt(32) || n < -(BigInt(2) ** BigInt(32))) && (g = V0(g)), g += "n"), h += ` It must be ${r}. Received ${g}`, h;
    },
    RangeError
  );
  function V0(c) {
    let r = "", n = c.length;
    const h = c[0] === "-" ? 1 : 0;
    for (; n >= h + 4; n -= 3)
      r = `_${c.slice(n - 3, n)}${r}`;
    return `${c.slice(0, n)}${r}`;
  }
  function oe(c, r, n) {
    E2(r, "offset"), (c[r] === void 0 || c[r + n] === void 0) && M2(r, c.length - (n + 1));
  }
  function J0(c, r, n, h, g, m) {
    if (c > n || c < r) {
      const y = typeof r == "bigint" ? "n" : "";
      let _;
      throw r === 0 || r === BigInt(0) ? _ = `>= 0${y} and < 2${y} ** ${(m + 1) * 8}${y}` : _ = `>= -(2${y} ** ${(m + 1) * 8 - 1}${y}) and < 2 ** ${(m + 1) * 8 - 1}${y}`, new _2.ERR_OUT_OF_RANGE("value", _, c);
    }
    oe(h, g, m);
  }
  function E2(c, r) {
    if (typeof c != "number")
      throw new _2.ERR_INVALID_ARG_TYPE(r, "number", c);
  }
  function M2(c, r, n) {
    throw Math.floor(c) !== c ? (E2(c, n), new _2.ERR_OUT_OF_RANGE("offset", "an integer", c)) : r < 0 ? new _2.ERR_BUFFER_OUT_OF_BOUNDS() : new _2.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${r}`,
      c
    );
  }
  const ae = /[^+/0-9A-Za-z-_]/g;
  function se(c) {
    if (c = c.split("=")[0], c = c.trim().replace(ae, ""), c.length < 2) return "";
    for (; c.length % 4 !== 0; )
      c = c + "=";
    return c;
  }
  function b0(c, r) {
    r = r || 1 / 0;
    let n;
    const h = c.length;
    let g = null;
    const m = [];
    for (let y = 0; y < h; ++y) {
      if (n = c.charCodeAt(y), n > 55295 && n < 57344) {
        if (!g) {
          if (n > 56319) {
            (r -= 3) > -1 && m.push(239, 191, 189);
            continue;
          } else if (y + 1 === h) {
            (r -= 3) > -1 && m.push(239, 191, 189);
            continue;
          }
          g = n;
          continue;
        }
        if (n < 56320) {
          (r -= 3) > -1 && m.push(239, 191, 189), g = n;
          continue;
        }
        n = (g - 55296 << 10 | n - 56320) + 65536;
      } else g && (r -= 3) > -1 && m.push(239, 191, 189);
      if (g = null, n < 128) {
        if ((r -= 1) < 0) break;
        m.push(n);
      } else if (n < 2048) {
        if ((r -= 2) < 0) break;
        m.push(
          n >> 6 | 192,
          n & 63 | 128
        );
      } else if (n < 65536) {
        if ((r -= 3) < 0) break;
        m.push(
          n >> 12 | 224,
          n >> 6 & 63 | 128,
          n & 63 | 128
        );
      } else if (n < 1114112) {
        if ((r -= 4) < 0) break;
        m.push(
          n >> 18 | 240,
          n >> 12 & 63 | 128,
          n >> 6 & 63 | 128,
          n & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return m;
  }
  function ce(c) {
    const r = [];
    for (let n = 0; n < c.length; ++n)
      r.push(c.charCodeAt(n) & 255);
    return r;
  }
  function ue(c, r) {
    let n, h, g;
    const m = [];
    for (let y = 0; y < c.length && !((r -= 2) < 0); ++y)
      n = c.charCodeAt(y), h = n >> 8, g = n % 256, m.push(g), m.push(h);
    return m;
  }
  function Y0(c) {
    return t.toByteArray(se(c));
  }
  function r0(c, r, n, h) {
    let g;
    for (g = 0; g < h && !(g + n >= r.length || g >= c.length); ++g)
      r[g + n] = c[g];
    return g;
  }
  function J(c, r) {
    return c instanceof r || c != null && c.constructor != null && c.constructor.name != null && c.constructor.name === r.name;
  }
  function x0(c) {
    return c !== c;
  }
  const he = function() {
    const c = "0123456789abcdef", r = new Array(256);
    for (let n = 0; n < 16; ++n) {
      const h = n * 16;
      for (let g = 0; g < 16; ++g)
        r[h + g] = c[n] + c[g];
    }
    return r;
  }();
  function l2(c) {
    return typeof BigInt > "u" ? fe : c;
  }
  function fe() {
    throw new Error("BigInt not supported");
  }
})(D);
const W = D.Buffer, Me = D.Blob, qe = D.BlobOptions, We = D.Buffer, ze = D.File, Ze = D.FileOptions, He = D.INSPECT_MAX_BYTES, Ke = D.SlowBuffer, Ge = D.TranscodeEncoding, Ve = D.atob, Je = D.btoa, Ye = D.constants, Xe = D.isAscii, Qe = D.isUtf8, et = D.kMaxLength, tt = D.kStringMaxLength, rt = D.resolveObjectURL, nt = D.transcode, An = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Blob: Me,
  BlobOptions: qe,
  Buffer: We,
  File: ze,
  FileOptions: Ze,
  INSPECT_MAX_BYTES: He,
  SlowBuffer: Ke,
  TranscodeEncoding: Ge,
  atob: Ve,
  btoa: Je,
  constants: Ye,
  default: W,
  isAscii: Xe,
  isUtf8: Qe,
  kMaxLength: et,
  kStringMaxLength: tt,
  resolveObjectURL: rt,
  transcode: nt
}, Symbol.toStringTag, { value: "Module" }));
var d0 = {}, E = {}, J2 = x1;
function x1(e, t) {
  if (!e)
    throw new Error(t || "Assertion failed");
}
x1.equal = function(t, i, a) {
  if (t != i)
    throw new Error(a || "Assertion failed: " + t + " != " + i);
};
var A0 = { exports: {} };
typeof Object.create == "function" ? A0.exports = function(t, i) {
  i && (t.super_ = i, t.prototype = Object.create(i.prototype, {
    constructor: {
      value: t,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : A0.exports = function(t, i) {
  if (i) {
    t.super_ = i;
    var a = function() {
    };
    a.prototype = i.prototype, t.prototype = new a(), t.prototype.constructor = t;
  }
};
var it = A0.exports, ot = J2, at = it;
E.inherits = at;
function st(e, t) {
  return (e.charCodeAt(t) & 64512) !== 55296 || t < 0 || t + 1 >= e.length ? !1 : (e.charCodeAt(t + 1) & 64512) === 56320;
}
function ct(e, t) {
  if (Array.isArray(e))
    return e.slice();
  if (!e)
    return [];
  var i = [];
  if (typeof e == "string")
    if (t) {
      if (t === "hex")
        for (e = e.replace(/[^a-z0-9]+/ig, ""), e.length % 2 !== 0 && (e = "0" + e), o = 0; o < e.length; o += 2)
          i.push(parseInt(e[o] + e[o + 1], 16));
    } else for (var a = 0, o = 0; o < e.length; o++) {
      var s = e.charCodeAt(o);
      s < 128 ? i[a++] = s : s < 2048 ? (i[a++] = s >> 6 | 192, i[a++] = s & 63 | 128) : st(e, o) ? (s = 65536 + ((s & 1023) << 10) + (e.charCodeAt(++o) & 1023), i[a++] = s >> 18 | 240, i[a++] = s >> 12 & 63 | 128, i[a++] = s >> 6 & 63 | 128, i[a++] = s & 63 | 128) : (i[a++] = s >> 12 | 224, i[a++] = s >> 6 & 63 | 128, i[a++] = s & 63 | 128);
    }
  else
    for (o = 0; o < e.length; o++)
      i[o] = e[o] | 0;
  return i;
}
E.toArray = ct;
function ut(e) {
  for (var t = "", i = 0; i < e.length; i++)
    t += y1(e[i].toString(16));
  return t;
}
E.toHex = ut;
function w1(e) {
  var t = e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (e & 255) << 24;
  return t >>> 0;
}
E.htonl = w1;
function ht(e, t) {
  for (var i = "", a = 0; a < e.length; a++) {
    var o = e[a];
    t === "little" && (o = w1(o)), i += v1(o.toString(16));
  }
  return i;
}
E.toHex32 = ht;
function y1(e) {
  return e.length === 1 ? "0" + e : e;
}
E.zero2 = y1;
function v1(e) {
  return e.length === 7 ? "0" + e : e.length === 6 ? "00" + e : e.length === 5 ? "000" + e : e.length === 4 ? "0000" + e : e.length === 3 ? "00000" + e : e.length === 2 ? "000000" + e : e.length === 1 ? "0000000" + e : e;
}
E.zero8 = v1;
function ft(e, t, i, a) {
  var o = i - t;
  ot(o % 4 === 0);
  for (var s = new Array(o / 4), f = 0, p = t; f < s.length; f++, p += 4) {
    var d;
    a === "big" ? d = e[p] << 24 | e[p + 1] << 16 | e[p + 2] << 8 | e[p + 3] : d = e[p + 3] << 24 | e[p + 2] << 16 | e[p + 1] << 8 | e[p], s[f] = d >>> 0;
  }
  return s;
}
E.join32 = ft;
function lt(e, t) {
  for (var i = new Array(e.length * 4), a = 0, o = 0; a < e.length; a++, o += 4) {
    var s = e[a];
    t === "big" ? (i[o] = s >>> 24, i[o + 1] = s >>> 16 & 255, i[o + 2] = s >>> 8 & 255, i[o + 3] = s & 255) : (i[o + 3] = s >>> 24, i[o + 2] = s >>> 16 & 255, i[o + 1] = s >>> 8 & 255, i[o] = s & 255);
  }
  return i;
}
E.split32 = lt;
function dt(e, t) {
  return e >>> t | e << 32 - t;
}
E.rotr32 = dt;
function pt(e, t) {
  return e << t | e >>> 32 - t;
}
E.rotl32 = pt;
function gt(e, t) {
  return e + t >>> 0;
}
E.sum32 = gt;
function mt(e, t, i) {
  return e + t + i >>> 0;
}
E.sum32_3 = mt;
function bt(e, t, i, a) {
  return e + t + i + a >>> 0;
}
E.sum32_4 = bt;
function xt(e, t, i, a, o) {
  return e + t + i + a + o >>> 0;
}
E.sum32_5 = xt;
function wt(e, t, i, a) {
  var o = e[t], s = e[t + 1], f = a + s >>> 0, p = (f < a ? 1 : 0) + i + o;
  e[t] = p >>> 0, e[t + 1] = f;
}
E.sum64 = wt;
function yt(e, t, i, a) {
  var o = t + a >>> 0, s = (o < t ? 1 : 0) + e + i;
  return s >>> 0;
}
E.sum64_hi = yt;
function vt(e, t, i, a) {
  var o = t + a;
  return o >>> 0;
}
E.sum64_lo = vt;
function Ct(e, t, i, a, o, s, f, p) {
  var d = 0, l = t;
  l = l + a >>> 0, d += l < t ? 1 : 0, l = l + s >>> 0, d += l < s ? 1 : 0, l = l + p >>> 0, d += l < p ? 1 : 0;
  var u = e + i + o + f + d;
  return u >>> 0;
}
E.sum64_4_hi = Ct;
function _t(e, t, i, a, o, s, f, p) {
  var d = t + a + s + p;
  return d >>> 0;
}
E.sum64_4_lo = _t;
function Et(e, t, i, a, o, s, f, p, d, l) {
  var u = 0, b = t;
  b = b + a >>> 0, u += b < t ? 1 : 0, b = b + s >>> 0, u += b < s ? 1 : 0, b = b + p >>> 0, u += b < p ? 1 : 0, b = b + l >>> 0, u += b < l ? 1 : 0;
  var x = e + i + o + f + d + u;
  return x >>> 0;
}
E.sum64_5_hi = Et;
function Bt(e, t, i, a, o, s, f, p, d, l) {
  var u = t + a + s + p + l;
  return u >>> 0;
}
E.sum64_5_lo = Bt;
function It(e, t, i) {
  var a = t << 32 - i | e >>> i;
  return a >>> 0;
}
E.rotr64_hi = It;
function At(e, t, i) {
  var a = e << 32 - i | t >>> i;
  return a >>> 0;
}
E.rotr64_lo = At;
function St(e, t, i) {
  return e >>> i;
}
E.shr64_hi = St;
function Ut(e, t, i) {
  var a = e << 32 - i | t >>> i;
  return a >>> 0;
}
E.shr64_lo = Ut;
var O2 = {}, t1 = E, Ft = J2;
function p0() {
  this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
}
O2.BlockHash = p0;
p0.prototype.update = function(t, i) {
  if (t = t1.toArray(t, i), this.pending ? this.pending = this.pending.concat(t) : this.pending = t, this.pendingTotal += t.length, this.pending.length >= this._delta8) {
    t = this.pending;
    var a = t.length % this._delta8;
    this.pending = t.slice(t.length - a, t.length), this.pending.length === 0 && (this.pending = null), t = t1.join32(t, 0, t.length - a, this.endian);
    for (var o = 0; o < t.length; o += this._delta32)
      this._update(t, o, o + this._delta32);
  }
  return this;
};
p0.prototype.digest = function(t) {
  return this.update(this._pad()), Ft(this.pending === null), this._digest(t);
};
p0.prototype._pad = function() {
  var t = this.pendingTotal, i = this._delta8, a = i - (t + this.padLength) % i, o = new Array(a + this.padLength);
  o[0] = 128;
  for (var s = 1; s < a; s++)
    o[s] = 0;
  if (t <<= 3, this.endian === "big") {
    for (var f = 8; f < this.padLength; f++)
      o[s++] = 0;
    o[s++] = 0, o[s++] = 0, o[s++] = 0, o[s++] = 0, o[s++] = t >>> 24 & 255, o[s++] = t >>> 16 & 255, o[s++] = t >>> 8 & 255, o[s++] = t & 255;
  } else
    for (o[s++] = t & 255, o[s++] = t >>> 8 & 255, o[s++] = t >>> 16 & 255, o[s++] = t >>> 24 & 255, o[s++] = 0, o[s++] = 0, o[s++] = 0, o[s++] = 0, f = 8; f < this.padLength; f++)
      o[s++] = 0;
  return o;
};
var R2 = {}, a2 = {}, kt = E, e2 = kt.rotr32;
function Pt(e, t, i, a) {
  if (e === 0)
    return C1(t, i, a);
  if (e === 1 || e === 3)
    return E1(t, i, a);
  if (e === 2)
    return _1(t, i, a);
}
a2.ft_1 = Pt;
function C1(e, t, i) {
  return e & t ^ ~e & i;
}
a2.ch32 = C1;
function _1(e, t, i) {
  return e & t ^ e & i ^ t & i;
}
a2.maj32 = _1;
function E1(e, t, i) {
  return e ^ t ^ i;
}
a2.p32 = E1;
function Ot(e) {
  return e2(e, 2) ^ e2(e, 13) ^ e2(e, 22);
}
a2.s0_256 = Ot;
function Rt(e) {
  return e2(e, 6) ^ e2(e, 11) ^ e2(e, 25);
}
a2.s1_256 = Rt;
function Dt(e) {
  return e2(e, 7) ^ e2(e, 18) ^ e >>> 3;
}
a2.g0_256 = Dt;
function Lt(e) {
  return e2(e, 17) ^ e2(e, 19) ^ e >>> 10;
}
a2.g1_256 = Lt;
var U2 = E, $t = O2, Nt = a2, v0 = U2.rotl32, q2 = U2.sum32, Tt = U2.sum32_5, jt = Nt.ft_1, B1 = $t.BlockHash, Mt = [
  1518500249,
  1859775393,
  2400959708,
  3395469782
];
function n2() {
  if (!(this instanceof n2))
    return new n2();
  B1.call(this), this.h = [
    1732584193,
    4023233417,
    2562383102,
    271733878,
    3285377520
  ], this.W = new Array(80);
}
U2.inherits(n2, B1);
var qt = n2;
n2.blockSize = 512;
n2.outSize = 160;
n2.hmacStrength = 80;
n2.padLength = 64;
n2.prototype._update = function(t, i) {
  for (var a = this.W, o = 0; o < 16; o++)
    a[o] = t[i + o];
  for (; o < a.length; o++)
    a[o] = v0(a[o - 3] ^ a[o - 8] ^ a[o - 14] ^ a[o - 16], 1);
  var s = this.h[0], f = this.h[1], p = this.h[2], d = this.h[3], l = this.h[4];
  for (o = 0; o < a.length; o++) {
    var u = ~~(o / 20), b = Tt(v0(s, 5), jt(u, f, p, d), l, a[o], Mt[u]);
    l = d, d = p, p = v0(f, 30), f = s, s = b;
  }
  this.h[0] = q2(this.h[0], s), this.h[1] = q2(this.h[1], f), this.h[2] = q2(this.h[2], p), this.h[3] = q2(this.h[3], d), this.h[4] = q2(this.h[4], l);
};
n2.prototype._digest = function(t) {
  return t === "hex" ? U2.toHex32(this.h, "big") : U2.split32(this.h, "big");
};
var F2 = E, Wt = O2, D2 = a2, zt = J2, G = F2.sum32, Zt = F2.sum32_4, Ht = F2.sum32_5, Kt = D2.ch32, Gt = D2.maj32, Vt = D2.s0_256, Jt = D2.s1_256, Yt = D2.g0_256, Xt = D2.g1_256, I1 = Wt.BlockHash, Qt = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
];
function i2() {
  if (!(this instanceof i2))
    return new i2();
  I1.call(this), this.h = [
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ], this.k = Qt, this.W = new Array(64);
}
F2.inherits(i2, I1);
var A1 = i2;
i2.blockSize = 512;
i2.outSize = 256;
i2.hmacStrength = 192;
i2.padLength = 64;
i2.prototype._update = function(t, i) {
  for (var a = this.W, o = 0; o < 16; o++)
    a[o] = t[i + o];
  for (; o < a.length; o++)
    a[o] = Zt(Xt(a[o - 2]), a[o - 7], Yt(a[o - 15]), a[o - 16]);
  var s = this.h[0], f = this.h[1], p = this.h[2], d = this.h[3], l = this.h[4], u = this.h[5], b = this.h[6], x = this.h[7];
  for (zt(this.k.length === a.length), o = 0; o < a.length; o++) {
    var w = Ht(x, Jt(l), Kt(l, u, b), this.k[o], a[o]), v = G(Vt(s), Gt(s, f, p));
    x = b, b = u, u = l, l = G(d, w), d = p, p = f, f = s, s = G(w, v);
  }
  this.h[0] = G(this.h[0], s), this.h[1] = G(this.h[1], f), this.h[2] = G(this.h[2], p), this.h[3] = G(this.h[3], d), this.h[4] = G(this.h[4], l), this.h[5] = G(this.h[5], u), this.h[6] = G(this.h[6], b), this.h[7] = G(this.h[7], x);
};
i2.prototype._digest = function(t) {
  return t === "hex" ? F2.toHex32(this.h, "big") : F2.split32(this.h, "big");
};
var S0 = E, S1 = A1;
function u2() {
  if (!(this instanceof u2))
    return new u2();
  S1.call(this), this.h = [
    3238371032,
    914150663,
    812702999,
    4144912697,
    4290775857,
    1750603025,
    1694076839,
    3204075428
  ];
}
S0.inherits(u2, S1);
var e3 = u2;
u2.blockSize = 512;
u2.outSize = 224;
u2.hmacStrength = 192;
u2.padLength = 64;
u2.prototype._digest = function(t) {
  return t === "hex" ? S0.toHex32(this.h.slice(0, 7), "big") : S0.split32(this.h.slice(0, 7), "big");
};
var j = E, t3 = O2, r3 = J2, t2 = j.rotr64_hi, r2 = j.rotr64_lo, U1 = j.shr64_hi, F1 = j.shr64_lo, d2 = j.sum64, C0 = j.sum64_hi, _0 = j.sum64_lo, n3 = j.sum64_4_hi, i3 = j.sum64_4_lo, o3 = j.sum64_5_hi, a3 = j.sum64_5_lo, k1 = t3.BlockHash, s3 = [
  1116352408,
  3609767458,
  1899447441,
  602891725,
  3049323471,
  3964484399,
  3921009573,
  2173295548,
  961987163,
  4081628472,
  1508970993,
  3053834265,
  2453635748,
  2937671579,
  2870763221,
  3664609560,
  3624381080,
  2734883394,
  310598401,
  1164996542,
  607225278,
  1323610764,
  1426881987,
  3590304994,
  1925078388,
  4068182383,
  2162078206,
  991336113,
  2614888103,
  633803317,
  3248222580,
  3479774868,
  3835390401,
  2666613458,
  4022224774,
  944711139,
  264347078,
  2341262773,
  604807628,
  2007800933,
  770255983,
  1495990901,
  1249150122,
  1856431235,
  1555081692,
  3175218132,
  1996064986,
  2198950837,
  2554220882,
  3999719339,
  2821834349,
  766784016,
  2952996808,
  2566594879,
  3210313671,
  3203337956,
  3336571891,
  1034457026,
  3584528711,
  2466948901,
  113926993,
  3758326383,
  338241895,
  168717936,
  666307205,
  1188179964,
  773529912,
  1546045734,
  1294757372,
  1522805485,
  1396182291,
  2643833823,
  1695183700,
  2343527390,
  1986661051,
  1014477480,
  2177026350,
  1206759142,
  2456956037,
  344077627,
  2730485921,
  1290863460,
  2820302411,
  3158454273,
  3259730800,
  3505952657,
  3345764771,
  106217008,
  3516065817,
  3606008344,
  3600352804,
  1432725776,
  4094571909,
  1467031594,
  275423344,
  851169720,
  430227734,
  3100823752,
  506948616,
  1363258195,
  659060556,
  3750685593,
  883997877,
  3785050280,
  958139571,
  3318307427,
  1322822218,
  3812723403,
  1537002063,
  2003034995,
  1747873779,
  3602036899,
  1955562222,
  1575990012,
  2024104815,
  1125592928,
  2227730452,
  2716904306,
  2361852424,
  442776044,
  2428436474,
  593698344,
  2756734187,
  3733110249,
  3204031479,
  2999351573,
  3329325298,
  3815920427,
  3391569614,
  3928383900,
  3515267271,
  566280711,
  3940187606,
  3454069534,
  4118630271,
  4000239992,
  116418474,
  1914138554,
  174292421,
  2731055270,
  289380356,
  3203993006,
  460393269,
  320620315,
  685471733,
  587496836,
  852142971,
  1086792851,
  1017036298,
  365543100,
  1126000580,
  2618297676,
  1288033470,
  3409855158,
  1501505948,
  4234509866,
  1607167915,
  987167468,
  1816402316,
  1246189591
];
function V() {
  if (!(this instanceof V))
    return new V();
  k1.call(this), this.h = [
    1779033703,
    4089235720,
    3144134277,
    2227873595,
    1013904242,
    4271175723,
    2773480762,
    1595750129,
    1359893119,
    2917565137,
    2600822924,
    725511199,
    528734635,
    4215389547,
    1541459225,
    327033209
  ], this.k = s3, this.W = new Array(160);
}
j.inherits(V, k1);
var P1 = V;
V.blockSize = 1024;
V.outSize = 512;
V.hmacStrength = 192;
V.padLength = 128;
V.prototype._prepareBlock = function(t, i) {
  for (var a = this.W, o = 0; o < 32; o++)
    a[o] = t[i + o];
  for (; o < a.length; o += 2) {
    var s = x3(a[o - 4], a[o - 3]), f = w3(a[o - 4], a[o - 3]), p = a[o - 14], d = a[o - 13], l = m3(a[o - 30], a[o - 29]), u = b3(a[o - 30], a[o - 29]), b = a[o - 32], x = a[o - 31];
    a[o] = n3(
      s,
      f,
      p,
      d,
      l,
      u,
      b,
      x
    ), a[o + 1] = i3(
      s,
      f,
      p,
      d,
      l,
      u,
      b,
      x
    );
  }
};
V.prototype._update = function(t, i) {
  this._prepareBlock(t, i);
  var a = this.W, o = this.h[0], s = this.h[1], f = this.h[2], p = this.h[3], d = this.h[4], l = this.h[5], u = this.h[6], b = this.h[7], x = this.h[8], w = this.h[9], v = this.h[10], C = this.h[11], B = this.h[12], F = this.h[13], I = this.h[14], S = this.h[15];
  r3(this.k.length === a.length);
  for (var O = 0; O < a.length; O += 2) {
    var M = I, f2 = S, m2 = p3(x, w), q = g3(x, w), $2 = c3(x, w, v, C, B), N2 = u3(x, w, v, C, B, F), X2 = this.k[O], Q2 = this.k[O + 1], e0 = a[O], t0 = a[O + 1], v2 = o3(
      M,
      f2,
      m2,
      q,
      $2,
      N2,
      X2,
      Q2,
      e0,
      t0
    ), C2 = a3(
      M,
      f2,
      m2,
      q,
      $2,
      N2,
      X2,
      Q2,
      e0,
      t0
    );
    M = l3(o, s), f2 = d3(o, s), m2 = h3(o, s, f, p, d), q = f3(o, s, f, p, d, l);
    var T2 = C0(M, f2, m2, q), j2 = _0(M, f2, m2, q);
    I = B, S = F, B = v, F = C, v = x, C = w, x = C0(u, b, v2, C2), w = _0(b, b, v2, C2), u = d, b = l, d = f, l = p, f = o, p = s, o = C0(v2, C2, T2, j2), s = _0(v2, C2, T2, j2);
  }
  d2(this.h, 0, o, s), d2(this.h, 2, f, p), d2(this.h, 4, d, l), d2(this.h, 6, u, b), d2(this.h, 8, x, w), d2(this.h, 10, v, C), d2(this.h, 12, B, F), d2(this.h, 14, I, S);
};
V.prototype._digest = function(t) {
  return t === "hex" ? j.toHex32(this.h, "big") : j.split32(this.h, "big");
};
function c3(e, t, i, a, o) {
  var s = e & i ^ ~e & o;
  return s < 0 && (s += 4294967296), s;
}
function u3(e, t, i, a, o, s) {
  var f = t & a ^ ~t & s;
  return f < 0 && (f += 4294967296), f;
}
function h3(e, t, i, a, o) {
  var s = e & i ^ e & o ^ i & o;
  return s < 0 && (s += 4294967296), s;
}
function f3(e, t, i, a, o, s) {
  var f = t & a ^ t & s ^ a & s;
  return f < 0 && (f += 4294967296), f;
}
function l3(e, t) {
  var i = t2(e, t, 28), a = t2(t, e, 2), o = t2(t, e, 7), s = i ^ a ^ o;
  return s < 0 && (s += 4294967296), s;
}
function d3(e, t) {
  var i = r2(e, t, 28), a = r2(t, e, 2), o = r2(t, e, 7), s = i ^ a ^ o;
  return s < 0 && (s += 4294967296), s;
}
function p3(e, t) {
  var i = t2(e, t, 14), a = t2(e, t, 18), o = t2(t, e, 9), s = i ^ a ^ o;
  return s < 0 && (s += 4294967296), s;
}
function g3(e, t) {
  var i = r2(e, t, 14), a = r2(e, t, 18), o = r2(t, e, 9), s = i ^ a ^ o;
  return s < 0 && (s += 4294967296), s;
}
function m3(e, t) {
  var i = t2(e, t, 1), a = t2(e, t, 8), o = U1(e, t, 7), s = i ^ a ^ o;
  return s < 0 && (s += 4294967296), s;
}
function b3(e, t) {
  var i = r2(e, t, 1), a = r2(e, t, 8), o = F1(e, t, 7), s = i ^ a ^ o;
  return s < 0 && (s += 4294967296), s;
}
function x3(e, t) {
  var i = t2(e, t, 19), a = t2(t, e, 29), o = U1(e, t, 6), s = i ^ a ^ o;
  return s < 0 && (s += 4294967296), s;
}
function w3(e, t) {
  var i = r2(e, t, 19), a = r2(t, e, 29), o = F1(e, t, 6), s = i ^ a ^ o;
  return s < 0 && (s += 4294967296), s;
}
var U0 = E, O1 = P1;
function h2() {
  if (!(this instanceof h2))
    return new h2();
  O1.call(this), this.h = [
    3418070365,
    3238371032,
    1654270250,
    914150663,
    2438529370,
    812702999,
    355462360,
    4144912697,
    1731405415,
    4290775857,
    2394180231,
    1750603025,
    3675008525,
    1694076839,
    1203062813,
    3204075428
  ];
}
U0.inherits(h2, O1);
var y3 = h2;
h2.blockSize = 1024;
h2.outSize = 384;
h2.hmacStrength = 192;
h2.padLength = 128;
h2.prototype._digest = function(t) {
  return t === "hex" ? U0.toHex32(this.h.slice(0, 12), "big") : U0.split32(this.h.slice(0, 12), "big");
};
R2.sha1 = qt;
R2.sha224 = e3;
R2.sha256 = A1;
R2.sha384 = y3;
R2.sha512 = P1;
var R1 = {}, w2 = E, v3 = O2, n0 = w2.rotl32, r1 = w2.sum32, W2 = w2.sum32_3, n1 = w2.sum32_4, D1 = v3.BlockHash;
function o2() {
  if (!(this instanceof o2))
    return new o2();
  D1.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
}
w2.inherits(o2, D1);
R1.ripemd160 = o2;
o2.blockSize = 512;
o2.outSize = 160;
o2.hmacStrength = 192;
o2.padLength = 64;
o2.prototype._update = function(t, i) {
  for (var a = this.h[0], o = this.h[1], s = this.h[2], f = this.h[3], p = this.h[4], d = a, l = o, u = s, b = f, x = p, w = 0; w < 80; w++) {
    var v = r1(
      n0(
        n1(a, i1(w, o, s, f), t[E3[w] + i], C3(w)),
        I3[w]
      ),
      p
    );
    a = p, p = f, f = n0(s, 10), s = o, o = v, v = r1(
      n0(
        n1(d, i1(79 - w, l, u, b), t[B3[w] + i], _3(w)),
        A3[w]
      ),
      x
    ), d = x, x = b, b = n0(u, 10), u = l, l = v;
  }
  v = W2(this.h[1], s, b), this.h[1] = W2(this.h[2], f, x), this.h[2] = W2(this.h[3], p, d), this.h[3] = W2(this.h[4], a, l), this.h[4] = W2(this.h[0], o, u), this.h[0] = v;
};
o2.prototype._digest = function(t) {
  return t === "hex" ? w2.toHex32(this.h, "little") : w2.split32(this.h, "little");
};
function i1(e, t, i, a) {
  return e <= 15 ? t ^ i ^ a : e <= 31 ? t & i | ~t & a : e <= 47 ? (t | ~i) ^ a : e <= 63 ? t & a | i & ~a : t ^ (i | ~a);
}
function C3(e) {
  return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
}
function _3(e) {
  return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
}
var E3 = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8,
  3,
  10,
  14,
  4,
  9,
  15,
  8,
  1,
  2,
  7,
  0,
  6,
  13,
  11,
  5,
  12,
  1,
  9,
  11,
  10,
  0,
  8,
  12,
  4,
  13,
  3,
  7,
  15,
  14,
  5,
  6,
  2,
  4,
  0,
  5,
  9,
  7,
  12,
  2,
  10,
  14,
  1,
  3,
  8,
  11,
  6,
  15,
  13
], B3 = [
  5,
  14,
  7,
  0,
  9,
  2,
  11,
  4,
  13,
  6,
  15,
  8,
  1,
  10,
  3,
  12,
  6,
  11,
  3,
  7,
  0,
  13,
  5,
  10,
  14,
  15,
  8,
  12,
  4,
  9,
  1,
  2,
  15,
  5,
  1,
  3,
  7,
  14,
  6,
  9,
  11,
  8,
  12,
  2,
  10,
  0,
  4,
  13,
  8,
  6,
  4,
  1,
  3,
  11,
  15,
  0,
  5,
  12,
  2,
  13,
  9,
  7,
  10,
  14,
  12,
  15,
  10,
  4,
  1,
  5,
  8,
  7,
  6,
  2,
  13,
  14,
  0,
  3,
  9,
  11
], I3 = [
  11,
  14,
  15,
  12,
  5,
  8,
  7,
  9,
  11,
  13,
  14,
  15,
  6,
  7,
  9,
  8,
  7,
  6,
  8,
  13,
  11,
  9,
  7,
  15,
  7,
  12,
  15,
  9,
  11,
  7,
  13,
  12,
  11,
  13,
  6,
  7,
  14,
  9,
  13,
  15,
  14,
  8,
  13,
  6,
  5,
  12,
  7,
  5,
  11,
  12,
  14,
  15,
  14,
  15,
  9,
  8,
  9,
  14,
  5,
  6,
  8,
  6,
  5,
  12,
  9,
  15,
  5,
  11,
  6,
  8,
  13,
  12,
  5,
  12,
  13,
  14,
  11,
  8,
  5,
  6
], A3 = [
  8,
  9,
  9,
  11,
  13,
  15,
  15,
  5,
  7,
  7,
  8,
  11,
  14,
  14,
  12,
  6,
  9,
  13,
  15,
  7,
  12,
  8,
  9,
  11,
  7,
  7,
  12,
  7,
  6,
  15,
  13,
  11,
  9,
  7,
  15,
  11,
  8,
  6,
  6,
  14,
  12,
  13,
  5,
  14,
  13,
  13,
  7,
  5,
  15,
  5,
  8,
  11,
  14,
  14,
  6,
  14,
  6,
  9,
  12,
  9,
  12,
  5,
  15,
  8,
  8,
  5,
  12,
  9,
  12,
  5,
  14,
  6,
  8,
  13,
  6,
  5,
  15,
  13,
  11,
  11
], S3 = E, U3 = J2;
function k2(e, t, i) {
  if (!(this instanceof k2))
    return new k2(e, t, i);
  this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(S3.toArray(t, i));
}
var F3 = k2;
k2.prototype._init = function(t) {
  t.length > this.blockSize && (t = new this.Hash().update(t).digest()), U3(t.length <= this.blockSize);
  for (var i = t.length; i < this.blockSize; i++)
    t.push(0);
  for (i = 0; i < t.length; i++)
    t[i] ^= 54;
  for (this.inner = new this.Hash().update(t), i = 0; i < t.length; i++)
    t[i] ^= 106;
  this.outer = new this.Hash().update(t);
};
k2.prototype.update = function(t, i) {
  return this.inner.update(t, i), this;
};
k2.prototype.digest = function(t) {
  return this.outer.update(this.inner.digest()), this.outer.digest(t);
};
(function(e) {
  var t = e;
  t.utils = E, t.common = O2, t.sha = R2, t.ripemd = R1, t.hmac = F3, t.sha1 = t.sha.sha1, t.sha256 = t.sha.sha256, t.sha224 = t.sha.sha224, t.sha384 = t.sha.sha384, t.sha512 = t.sha.sha512, t.ripemd160 = t.ripemd.ripemd160;
})(d0);
const k3 = /* @__PURE__ */ de(d0), P3 = /* @__PURE__ */ we({
  __proto__: null,
  default: k3
}, [d0]), O3 = typeof atob == "function", R3 = typeof btoa == "function", L2 = typeof W == "function", o1 = typeof TextDecoder == "function" ? new TextDecoder() : void 0, a1 = typeof TextEncoder == "function" ? new TextEncoder() : void 0, D3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", z2 = Array.prototype.slice.call(D3), i0 = ((e) => {
  let t = {};
  return e.forEach((i, a) => t[i] = a), t;
})(z2), L3 = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/, $ = String.fromCharCode.bind(String), s1 = typeof Uint8Array.from == "function" ? Uint8Array.from.bind(Uint8Array) : (e) => new Uint8Array(Array.prototype.slice.call(e, 0)), $3 = (e) => e.replace(/=/g, "").replace(/[+\/]/g, (t) => t == "+" ? "-" : "_"), L1 = (e) => e.replace(/[^A-Za-z0-9\+\/]/g, ""), N3 = (e) => {
  let t, i, a, o, s = "";
  const f = e.length % 3;
  for (let p = 0; p < e.length; ) {
    if ((i = e.charCodeAt(p++)) > 255 || (a = e.charCodeAt(p++)) > 255 || (o = e.charCodeAt(p++)) > 255)
      throw new TypeError("invalid character found");
    t = i << 16 | a << 8 | o, s += z2[t >> 18 & 63] + z2[t >> 12 & 63] + z2[t >> 6 & 63] + z2[t & 63];
  }
  return f ? s.slice(0, f - 3) + "===".substring(f) : s;
}, $1 = R3 ? (e) => btoa(e) : L2 ? (e) => W.from(e, "binary").toString("base64") : N3, T3 = L2 ? (e) => W.from(e).toString("base64") : (e) => {
  let i = [];
  for (let a = 0, o = e.length; a < o; a += 4096)
    i.push($.apply(null, e.subarray(a, a + 4096)));
  return $1(i.join(""));
}, j3 = (e) => {
  if (e.length < 2) {
    var t = e.charCodeAt(0);
    return t < 128 ? e : t < 2048 ? $(192 | t >>> 6) + $(128 | t & 63) : $(224 | t >>> 12 & 15) + $(128 | t >>> 6 & 63) + $(128 | t & 63);
  } else {
    var t = 65536 + (e.charCodeAt(0) - 55296) * 1024 + (e.charCodeAt(1) - 56320);
    return $(240 | t >>> 18 & 7) + $(128 | t >>> 12 & 63) + $(128 | t >>> 6 & 63) + $(128 | t & 63);
  }
}, M3 = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g, q3 = (e) => e.replace(M3, j3), c1 = L2 ? (e) => W.from(e, "utf8").toString("base64") : a1 ? (e) => T3(a1.encode(e)) : (e) => $1(q3(e)), W3 = (e, t = !1) => t ? $3(c1(e)) : c1(e), u1 = (e) => W3(e, !0), z3 = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g, Z3 = (e) => {
  switch (e.length) {
    case 4:
      var t = (7 & e.charCodeAt(0)) << 18 | (63 & e.charCodeAt(1)) << 12 | (63 & e.charCodeAt(2)) << 6 | 63 & e.charCodeAt(3), i = t - 65536;
      return $((i >>> 10) + 55296) + $((i & 1023) + 56320);
    case 3:
      return $((15 & e.charCodeAt(0)) << 12 | (63 & e.charCodeAt(1)) << 6 | 63 & e.charCodeAt(2));
    default:
      return $((31 & e.charCodeAt(0)) << 6 | 63 & e.charCodeAt(1));
  }
}, H3 = (e) => e.replace(z3, Z3), K3 = (e) => {
  if (e = e.replace(/\s+/g, ""), !L3.test(e))
    throw new TypeError("malformed base64.");
  e += "==".slice(2 - (e.length & 3));
  let t, i = "", a, o;
  for (let s = 0; s < e.length; )
    t = i0[e.charAt(s++)] << 18 | i0[e.charAt(s++)] << 12 | (a = i0[e.charAt(s++)]) << 6 | (o = i0[e.charAt(s++)]), i += a === 64 ? $(t >> 16 & 255) : o === 64 ? $(t >> 16 & 255, t >> 8 & 255) : $(t >> 16 & 255, t >> 8 & 255, t & 255);
  return i;
}, N1 = O3 ? (e) => atob(L1(e)) : L2 ? (e) => W.from(e, "base64").toString("binary") : K3, G3 = L2 ? (e) => s1(W.from(e, "base64")) : (e) => s1(N1(e).split("").map((t) => t.charCodeAt(0))), V3 = L2 ? (e) => W.from(e, "base64").toString("utf8") : o1 ? (e) => o1.decode(G3(e)) : (e) => H3(N1(e)), J3 = (e) => L1(e.replace(/[-_]/g, (t) => t == "-" ? "+" : "/")), Sn = (e) => V3(J3(e));
function F0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var i = 0, a = new Array(t); i < t; i++) a[i] = e[i];
  return a;
}
function Y3(e) {
  if (Array.isArray(e)) return F0(e);
}
function k0(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function g0(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function s0(e, t, i) {
  return T1() ? s0 = Reflect.construct : s0 = function(a, o, s) {
    var f = [null];
    f.push.apply(f, o);
    var p = Function.bind.apply(a, f), d = new p();
    return s && G2(d, s.prototype), d;
  }, s0.apply(null, arguments);
}
function X3(e, t) {
  for (var i = 0; i < t.length; i++) {
    var a = t[i];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
  }
}
function T0(e, t, i) {
  return t && X3(e.prototype, t), e;
}
function b2(e, t, i) {
  return t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = i, e;
}
function K2(e) {
  return K2 = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, K2(e);
}
function Q3(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && G2(e, t);
}
function er(e, t) {
  return t != null && typeof Symbol < "u" && t[Symbol.hasInstance] ? !!t[Symbol.hasInstance](e) : e instanceof t;
}
function tr(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function rr(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function nr() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ir(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {}, a = Object.keys(i);
    typeof Object.getOwnPropertySymbols == "function" && (a = a.concat(Object.getOwnPropertySymbols(i).filter(function(o) {
      return Object.getOwnPropertyDescriptor(i, o).enumerable;
    }))), a.forEach(function(o) {
      b2(e, o, i[o]);
    });
  }
  return e;
}
function or(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    i.push.apply(i, a);
  }
  return i;
}
function ar(e, t) {
  return t = t ?? {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : or(Object(t)).forEach(function(i) {
    Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
  }), e;
}
function sr(e, t) {
  return t && (K(t) === "object" || typeof t == "function") ? t : k0(e);
}
function G2(e, t) {
  return G2 = Object.setPrototypeOf || function(i, a) {
    return i.__proto__ = a, i;
  }, G2(e, t);
}
function Z2(e) {
  return Y3(e) || rr(e) || cr(e) || nr();
}
function K(e) {
  "@swc/helpers - typeof";
  return e && typeof Symbol < "u" && e.constructor === Symbol ? "symbol" : typeof e;
}
function cr(e, t) {
  if (e) {
    if (typeof e == "string") return F0(e, t);
    var i = Object.prototype.toString.call(e).slice(8, -1);
    if (i === "Object" && e.constructor && (i = e.constructor.name), i === "Map" || i === "Set") return Array.from(i);
    if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return F0(e, t);
  }
}
function P0(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return P0 = function(i) {
    if (i === null || !tr(i)) return i;
    if (typeof i != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(i)) return t.get(i);
      t.set(i, a);
    }
    function a() {
      return s0(i, arguments, K2(this).constructor);
    }
    return a.prototype = Object.create(i.prototype, { constructor: { value: a, enumerable: !1, writable: !0, configurable: !0 } }), G2(a, i);
  }, P0(e);
}
function T1() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function ur(e) {
  var t = T1();
  return function() {
    var a = K2(e), o;
    if (t) {
      var s = K2(this).constructor;
      o = Reflect.construct(a, arguments, s);
    } else
      o = a.apply(this, arguments);
    return sr(this, o);
  };
}
var hr = Object.defineProperty, fr = function(e, t, i) {
  return t in e ? hr(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i;
}, H = function(e, t, i) {
  return fr(e, (typeof t > "u" ? "undefined" : K(t)) != "symbol" ? t + "" : t, i), i;
}, p2, lr = "PARSE_ERROR", dr = "INVALID_REQUEST", pr = "METHOD_NOT_FOUND", gr = "INVALID_PARAMS", j1 = "INTERNAL_ERROR", j0 = "SERVER_ERROR", mr = [-32700, -32600, -32601, -32602, -32603], H2 = (p2 = {}, b2(p2, lr, { code: -32700, message: "Parse error" }), b2(p2, dr, { code: -32600, message: "Invalid Request" }), b2(p2, pr, { code: -32601, message: "Method not found" }), b2(p2, gr, { code: -32602, message: "Invalid params" }), b2(p2, j1, { code: -32603, message: "Internal error" }), b2(p2, j0, { code: -32e3, message: "Server error" }), p2), M1 = j0;
function br(e) {
  return mr.includes(e);
}
function h1(e) {
  return Object.keys(H2).includes(e) ? H2[e] : H2[M1];
}
function xr(e) {
  var t = Object.values(H2).find(function(i) {
    return i.code === e;
  });
  return t || H2[M1];
}
function Un(e, t, i) {
  return e.message.includes("getaddrinfo ENOTFOUND") || e.message.includes("connect ECONNREFUSED") ? new Error("Unavailable ".concat(i, " RPC url at ").concat(t)) : e;
}
function wr() {
  var e = Date.now() * Math.pow(10, 3), t = Math.floor(Math.random() * Math.pow(10, 3));
  return e + t;
}
function Fn() {
  return function(e, t) {
    for (t = e = ""; e++ < 36; t += e * 51 & 52 ? (e ^ 15 ? 8 ^ Math.random() * (e ^ 20 ? 16 : 4) : 4).toString(16) : "-") ;
    return t;
  }();
}
function kn(e, t, i) {
  return { id: i || wr(), jsonrpc: "2.0", method: e, params: t || [] };
}
function Pn(e, t, i) {
  return { id: e, jsonrpc: "2.0", error: yr(t) };
}
function yr(e, t) {
  return (typeof e > "u" ? "undefined" : K(e)) > "u" ? h1(j1) : (typeof e == "string" && (e = ar(ir({}, h1(j0)), { message: e })), br(e.code) && (e = xr(e.code)), e);
}
function On(e) {
  return "result" in e;
}
var vr = "^https?:";
function Cr(e) {
  var t = e.match(new RegExp(/^\w+:/, "gi"));
  if (!(!t || !t.length)) return t[0];
}
function _r(e, t) {
  var i = Cr(e);
  return (typeof i > "u" ? "undefined" : K(i)) > "u" ? !1 : new RegExp(t).test(i);
}
function Rn(e) {
  return _r(e, vr);
}
var Er = { 1: "mainnet", 3: "ropsten", 4: "rinkeby", 5: "goerli", 42: "kovan" }, Dn = ["eth_requestAccounts", "eth_accounts", "eth_chainId", "eth_signTransaction", "eth_sendTransaction", "eth_sign", "personal_sign", "eth_signTypedData", "eth_signTypedData_v1", "eth_signTypedData_v2", "eth_signTypedData_v3", "eth_signTypedData_v4", "wallet_switchEthereumChain", "wallet_watchAsset"];
function Br(e, t) {
  var i, a = Er[e];
  return typeof a == "string" && (i = "https://".concat(a, ".infura.io/v3/").concat(t)), i;
}
function Ln(e) {
  if (typeof e != "string") throw new Error("Cannot safe json parse value of type ".concat(typeof e > "u" ? "undefined" : K(e)));
  try {
    return JSON.parse(e);
  } catch {
    return e;
  }
}
function $n(e) {
  return typeof e == "string" ? e : JSON.stringify(e);
}
function Nn(e, t) {
  var i, a = Br(e, t.infuraId);
  return t.custom && t.custom[e] ? i = t.custom[e] : a && (i = a), i;
}
function Tn() {
  return (typeof process > "u" ? "undefined" : K(process)) < "u" && K(process.versions) < "u" && K(process.versions.node) < "u";
}
function E0(e) {
  return typeof e == "string" ? Number.parseInt(e, e.trim().substring(0, 2) === "0x" ? 16 : 10) : (typeof e > "u" ? "undefined" : K(e)) == "bigint" ? Number(e) : e;
}
var q1 = "hex", M0 = "utf8";
function O0(e) {
  return e.replace(/^0x/, "");
}
function x2(e) {
  return y2(W.from(O0(e), q1));
}
function S2(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return W1(Y2(e), t);
}
function y2(e) {
  return new Uint8Array(e);
}
function W1(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, i = e.toString(q1);
  return t ? Ar(i) : i;
}
function Ir(e) {
  return ArrayBuffer.isView(e) ? W.from(e.buffer, e.byteOffset, e.byteLength) : W.from(e);
}
function Y2(e) {
  return Ir(e);
}
function Ar(e) {
  return e.startsWith("0x") ? e : "0x".concat(e);
}
function z1() {
  for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
    t[i] = arguments[i];
  var a = [];
  return t.forEach(function(o) {
    return a = a.concat(Array.from(o));
  }), new Uint8Array(Z2(a));
}
function Sr(e) {
  return y2(W.from(e, M0));
}
function Ur(e) {
  return W.from(e, M0);
}
function Fr(e) {
  return e.toString(M0);
}
function kr(e) {
  return Fr(Y2(e));
}
function jn(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return W1(Ur(e), t);
}
function Mn(e) {
  return x2(e).buffer;
}
function qn(e, t) {
  return S2(new Uint8Array(e), !t);
}
function Pr(e) {
  return y2(e).buffer;
}
function R0(e) {
  return Y2(new Uint8Array(e));
}
function Wn(e) {
  var t = "0x0";
  return typeof e == "number" && (t = "0x".concat(e.toString(16))), typeof e == "string" && (e.startsWith("0x") ? t = e : t = "0x0"), t;
}
var Or = { 16: 10, 24: 12, 32: 14 }, Rr = [1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145], z = [99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22], o0 = [82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243, 215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68, 196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76, 149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178, 118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134, 104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112, 72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132, 144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179, 69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1, 19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207, 206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133, 226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41, 197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75, 198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31, 221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236, 95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147, 201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235, 187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38, 225, 105, 20, 99, 85, 33, 12, 125], Dr = [3328402341, 4168907908, 4000806809, 4135287693, 4294111757, 3597364157, 3731845041, 2445657428, 1613770832, 33620227, 3462883241, 1445669757, 3892248089, 3050821474, 1303096294, 3967186586, 2412431941, 528646813, 2311702848, 4202528135, 4026202645, 2992200171, 2387036105, 4226871307, 1101901292, 3017069671, 1604494077, 1169141738, 597466303, 1403299063, 3832705686, 2613100635, 1974974402, 3791519004, 1033081774, 1277568618, 1815492186, 2118074177, 4126668546, 2211236943, 1748251740, 1369810420, 3521504564, 4193382664, 3799085459, 2883115123, 1647391059, 706024767, 134480908, 2512897874, 1176707941, 2646852446, 806885416, 932615841, 168101135, 798661301, 235341577, 605164086, 461406363, 3756188221, 3454790438, 1311188841, 2142417613, 3933566367, 302582043, 495158174, 1479289972, 874125870, 907746093, 3698224818, 3025820398, 1537253627, 2756858614, 1983593293, 3084310113, 2108928974, 1378429307, 3722699582, 1580150641, 327451799, 2790478837, 3117535592, 0, 3253595436, 1075847264, 3825007647, 2041688520, 3059440621, 3563743934, 2378943302, 1740553945, 1916352843, 2487896798, 2555137236, 2958579944, 2244988746, 3151024235, 3320835882, 1336584933, 3992714006, 2252555205, 2588757463, 1714631509, 293963156, 2319795663, 3925473552, 67240454, 4269768577, 2689618160, 2017213508, 631218106, 1269344483, 2723238387, 1571005438, 2151694528, 93294474, 1066570413, 563977660, 1882732616, 4059428100, 1673313503, 2008463041, 2950355573, 1109467491, 537923632, 3858759450, 4260623118, 3218264685, 2177748300, 403442708, 638784309, 3287084079, 3193921505, 899127202, 2286175436, 773265209, 2479146071, 1437050866, 4236148354, 2050833735, 3362022572, 3126681063, 840505643, 3866325909, 3227541664, 427917720, 2655997905, 2749160575, 1143087718, 1412049534, 999329963, 193497219, 2353415882, 3354324521, 1807268051, 672404540, 2816401017, 3160301282, 369822493, 2916866934, 3688947771, 1681011286, 1949973070, 336202270, 2454276571, 201721354, 1210328172, 3093060836, 2680341085, 3184776046, 1135389935, 3294782118, 965841320, 831886756, 3554993207, 4068047243, 3588745010, 2345191491, 1849112409, 3664604599, 26054028, 2983581028, 2622377682, 1235855840, 3630984372, 2891339514, 4092916743, 3488279077, 3395642799, 4101667470, 1202630377, 268961816, 1874508501, 4034427016, 1243948399, 1546530418, 941366308, 1470539505, 1941222599, 2546386513, 3421038627, 2715671932, 3899946140, 1042226977, 2521517021, 1639824860, 227249030, 260737669, 3765465232, 2084453954, 1907733956, 3429263018, 2420656344, 100860677, 4160157185, 470683154, 3261161891, 1781871967, 2924959737, 1773779408, 394692241, 2579611992, 974986535, 664706745, 3655459128, 3958962195, 731420851, 571543859, 3530123707, 2849626480, 126783113, 865375399, 765172662, 1008606754, 361203602, 3387549984, 2278477385, 2857719295, 1344809080, 2782912378, 59542671, 1503764984, 160008576, 437062935, 1707065306, 3622233649, 2218934982, 3496503480, 2185314755, 697932208, 1512910199, 504303377, 2075177163, 2824099068, 1841019862, 739644986], Lr = [2781242211, 2230877308, 2582542199, 2381740923, 234877682, 3184946027, 2984144751, 1418839493, 1348481072, 50462977, 2848876391, 2102799147, 434634494, 1656084439, 3863849899, 2599188086, 1167051466, 2636087938, 1082771913, 2281340285, 368048890, 3954334041, 3381544775, 201060592, 3963727277, 1739838676, 4250903202, 3930435503, 3206782108, 4149453988, 2531553906, 1536934080, 3262494647, 484572669, 2923271059, 1783375398, 1517041206, 1098792767, 49674231, 1334037708, 1550332980, 4098991525, 886171109, 150598129, 2481090929, 1940642008, 1398944049, 1059722517, 201851908, 1385547719, 1699095331, 1587397571, 674240536, 2704774806, 252314885, 3039795866, 151914247, 908333586, 2602270848, 1038082786, 651029483, 1766729511, 3447698098, 2682942837, 454166793, 2652734339, 1951935532, 775166490, 758520603, 3000790638, 4004797018, 4217086112, 4137964114, 1299594043, 1639438038, 3464344499, 2068982057, 1054729187, 1901997871, 2534638724, 4121318227, 1757008337, 0, 750906861, 1614815264, 535035132, 3363418545, 3988151131, 3201591914, 1183697867, 3647454910, 1265776953, 3734260298, 3566750796, 3903871064, 1250283471, 1807470800, 717615087, 3847203498, 384695291, 3313910595, 3617213773, 1432761139, 2484176261, 3481945413, 283769337, 100925954, 2180939647, 4037038160, 1148730428, 3123027871, 3813386408, 4087501137, 4267549603, 3229630528, 2315620239, 2906624658, 3156319645, 1215313976, 82966005, 3747855548, 3245848246, 1974459098, 1665278241, 807407632, 451280895, 251524083, 1841287890, 1283575245, 337120268, 891687699, 801369324, 3787349855, 2721421207, 3431482436, 959321879, 1469301956, 4065699751, 2197585534, 1199193405, 2898814052, 3887750493, 724703513, 2514908019, 2696962144, 2551808385, 3516813135, 2141445340, 1715741218, 2119445034, 2872807568, 2198571144, 3398190662, 700968686, 3547052216, 1009259540, 2041044702, 3803995742, 487983883, 1991105499, 1004265696, 1449407026, 1316239930, 504629770, 3683797321, 168560134, 1816667172, 3837287516, 1570751170, 1857934291, 4014189740, 2797888098, 2822345105, 2754712981, 936633572, 2347923833, 852879335, 1133234376, 1500395319, 3084545389, 2348912013, 1689376213, 3533459022, 3762923945, 3034082412, 4205598294, 133428468, 634383082, 2949277029, 2398386810, 3913789102, 403703816, 3580869306, 2297460856, 1867130149, 1918643758, 607656988, 4049053350, 3346248884, 1368901318, 600565992, 2090982877, 2632479860, 557719327, 3717614411, 3697393085, 2249034635, 2232388234, 2430627952, 1115438654, 3295786421, 2865522278, 3633334344, 84280067, 33027830, 303828494, 2747425121, 1600795957, 4188952407, 3496589753, 2434238086, 1486471617, 658119965, 3106381470, 953803233, 334231800, 3005978776, 857870609, 3151128937, 1890179545, 2298973838, 2805175444, 3056442267, 574365214, 2450884487, 550103529, 1233637070, 4289353045, 2018519080, 2057691103, 2399374476, 4166623649, 2148108681, 387583245, 3664101311, 836232934, 3330556482, 3100665960, 3280093505, 2955516313, 2002398509, 287182607, 3413881008, 4238890068, 3597515707, 975967766], $r = [1671808611, 2089089148, 2006576759, 2072901243, 4061003762, 1807603307, 1873927791, 3310653893, 810573872, 16974337, 1739181671, 729634347, 4263110654, 3613570519, 2883997099, 1989864566, 3393556426, 2191335298, 3376449993, 2106063485, 4195741690, 1508618841, 1204391495, 4027317232, 2917941677, 3563566036, 2734514082, 2951366063, 2629772188, 2767672228, 1922491506, 3227229120, 3082974647, 4246528509, 2477669779, 644500518, 911895606, 1061256767, 4144166391, 3427763148, 878471220, 2784252325, 3845444069, 4043897329, 1905517169, 3631459288, 827548209, 356461077, 67897348, 3344078279, 593839651, 3277757891, 405286936, 2527147926, 84871685, 2595565466, 118033927, 305538066, 2157648768, 3795705826, 3945188843, 661212711, 2999812018, 1973414517, 152769033, 2208177539, 745822252, 439235610, 455947803, 1857215598, 1525593178, 2700827552, 1391895634, 994932283, 3596728278, 3016654259, 695947817, 3812548067, 795958831, 2224493444, 1408607827, 3513301457, 0, 3979133421, 543178784, 4229948412, 2982705585, 1542305371, 1790891114, 3410398667, 3201918910, 961245753, 1256100938, 1289001036, 1491644504, 3477767631, 3496721360, 4012557807, 2867154858, 4212583931, 1137018435, 1305975373, 861234739, 2241073541, 1171229253, 4178635257, 33948674, 2139225727, 1357946960, 1011120188, 2679776671, 2833468328, 1374921297, 2751356323, 1086357568, 2408187279, 2460827538, 2646352285, 944271416, 4110742005, 3168756668, 3066132406, 3665145818, 560153121, 271589392, 4279952895, 4077846003, 3530407890, 3444343245, 202643468, 322250259, 3962553324, 1608629855, 2543990167, 1154254916, 389623319, 3294073796, 2817676711, 2122513534, 1028094525, 1689045092, 1575467613, 422261273, 1939203699, 1621147744, 2174228865, 1339137615, 3699352540, 577127458, 712922154, 2427141008, 2290289544, 1187679302, 3995715566, 3100863416, 339486740, 3732514782, 1591917662, 186455563, 3681988059, 3762019296, 844522546, 978220090, 169743370, 1239126601, 101321734, 611076132, 1558493276, 3260915650, 3547250131, 2901361580, 1655096418, 2443721105, 2510565781, 3828863972, 2039214713, 3878868455, 3359869896, 928607799, 1840765549, 2374762893, 3580146133, 1322425422, 2850048425, 1823791212, 1459268694, 4094161908, 3928346602, 1706019429, 2056189050, 2934523822, 135794696, 3134549946, 2022240376, 628050469, 779246638, 472135708, 2800834470, 3032970164, 3327236038, 3894660072, 3715932637, 1956440180, 522272287, 1272813131, 3185336765, 2340818315, 2323976074, 1888542832, 1044544574, 3049550261, 1722469478, 1222152264, 50660867, 4127324150, 236067854, 1638122081, 895445557, 1475980887, 3117443513, 2257655686, 3243809217, 489110045, 2662934430, 3778599393, 4162055160, 2561878936, 288563729, 1773916777, 3648039385, 2391345038, 2493985684, 2612407707, 505560094, 2274497927, 3911240169, 3460925390, 1442818645, 678973480, 3749357023, 2358182796, 2717407649, 2306869641, 219617805, 3218761151, 3862026214, 1120306242, 1756942440, 1103331905, 2578459033, 762796589, 252780047, 2966125488, 1425844308, 3151392187, 372911126], Nr = [1667474886, 2088535288, 2004326894, 2071694838, 4075949567, 1802223062, 1869591006, 3318043793, 808472672, 16843522, 1734846926, 724270422, 4278065639, 3621216949, 2880169549, 1987484396, 3402253711, 2189597983, 3385409673, 2105378810, 4210693615, 1499065266, 1195886990, 4042263547, 2913856577, 3570689971, 2728590687, 2947541573, 2627518243, 2762274643, 1920112356, 3233831835, 3082273397, 4261223649, 2475929149, 640051788, 909531756, 1061110142, 4160160501, 3435941763, 875846760, 2779116625, 3857003729, 4059105529, 1903268834, 3638064043, 825316194, 353713962, 67374088, 3351728789, 589522246, 3284360861, 404236336, 2526454071, 84217610, 2593830191, 117901582, 303183396, 2155911963, 3806477791, 3958056653, 656894286, 2998062463, 1970642922, 151591698, 2206440989, 741110872, 437923380, 454765878, 1852748508, 1515908788, 2694904667, 1381168804, 993742198, 3604373943, 3014905469, 690584402, 3823320797, 791638366, 2223281939, 1398011302, 3520161977, 0, 3991743681, 538992704, 4244381667, 2981218425, 1532751286, 1785380564, 3419096717, 3200178535, 960056178, 1246420628, 1280103576, 1482221744, 3486468741, 3503319995, 4025428677, 2863326543, 4227536621, 1128514950, 1296947098, 859002214, 2240123921, 1162203018, 4193849577, 33687044, 2139062782, 1347481760, 1010582648, 2678045221, 2829640523, 1364325282, 2745433693, 1077985408, 2408548869, 2459086143, 2644360225, 943212656, 4126475505, 3166494563, 3065430391, 3671750063, 555836226, 269496352, 4294908645, 4092792573, 3537006015, 3452783745, 202118168, 320025894, 3974901699, 1600119230, 2543297077, 1145359496, 387397934, 3301201811, 2812801621, 2122220284, 1027426170, 1684319432, 1566435258, 421079858, 1936954854, 1616945344, 2172753945, 1330631070, 3705438115, 572679748, 707427924, 2425400123, 2290647819, 1179044492, 4008585671, 3099120491, 336870440, 3739122087, 1583276732, 185277718, 3688593069, 3772791771, 842159716, 976899700, 168435220, 1229577106, 101059084, 606366792, 1549591736, 3267517855, 3553849021, 2897014595, 1650632388, 2442242105, 2509612081, 3840161747, 2038008818, 3890688725, 3368567691, 926374254, 1835907034, 2374863873, 3587531953, 1313788572, 2846482505, 1819063512, 1448540844, 4109633523, 3941213647, 1701162954, 2054852340, 2930698567, 134748176, 3132806511, 2021165296, 623210314, 774795868, 471606328, 2795958615, 3031746419, 3334885783, 3907527627, 3722280097, 1953799400, 522133822, 1263263126, 3183336545, 2341176845, 2324333839, 1886425312, 1044267644, 3048588401, 1718004428, 1212733584, 50529542, 4143317495, 235803164, 1633788866, 892690282, 1465383342, 3115962473, 2256965911, 3250673817, 488449850, 2661202215, 3789633753, 4177007595, 2560144171, 286339874, 1768537042, 3654906025, 2391705863, 2492770099, 2610673197, 505291324, 2273808917, 3924369609, 3469625735, 1431699370, 673740880, 3755965093, 2358021891, 2711746649, 2307489801, 218961690, 3217021541, 3873845719, 1111672452, 1751693520, 1094828930, 2576986153, 757954394, 252645662, 2964376443, 1414855848, 3149649517, 370555436], Tr = [1374988112, 2118214995, 437757123, 975658646, 1001089995, 530400753, 2902087851, 1273168787, 540080725, 2910219766, 2295101073, 4110568485, 1340463100, 3307916247, 641025152, 3043140495, 3736164937, 632953703, 1172967064, 1576976609, 3274667266, 2169303058, 2370213795, 1809054150, 59727847, 361929877, 3211623147, 2505202138, 3569255213, 1484005843, 1239443753, 2395588676, 1975683434, 4102977912, 2572697195, 666464733, 3202437046, 4035489047, 3374361702, 2110667444, 1675577880, 3843699074, 2538681184, 1649639237, 2976151520, 3144396420, 4269907996, 4178062228, 1883793496, 2403728665, 2497604743, 1383856311, 2876494627, 1917518562, 3810496343, 1716890410, 3001755655, 800440835, 2261089178, 3543599269, 807962610, 599762354, 33778362, 3977675356, 2328828971, 2809771154, 4077384432, 1315562145, 1708848333, 101039829, 3509871135, 3299278474, 875451293, 2733856160, 92987698, 2767645557, 193195065, 1080094634, 1584504582, 3178106961, 1042385657, 2531067453, 3711829422, 1306967366, 2438237621, 1908694277, 67556463, 1615861247, 429456164, 3602770327, 2302690252, 1742315127, 2968011453, 126454664, 3877198648, 2043211483, 2709260871, 2084704233, 4169408201, 0, 159417987, 841739592, 504459436, 1817866830, 4245618683, 260388950, 1034867998, 908933415, 168810852, 1750902305, 2606453969, 607530554, 202008497, 2472011535, 3035535058, 463180190, 2160117071, 1641816226, 1517767529, 470948374, 3801332234, 3231722213, 1008918595, 303765277, 235474187, 4069246893, 766945465, 337553864, 1475418501, 2943682380, 4003061179, 2743034109, 4144047775, 1551037884, 1147550661, 1543208500, 2336434550, 3408119516, 3069049960, 3102011747, 3610369226, 1113818384, 328671808, 2227573024, 2236228733, 3535486456, 2935566865, 3341394285, 496906059, 3702665459, 226906860, 2009195472, 733156972, 2842737049, 294930682, 1206477858, 2835123396, 2700099354, 1451044056, 573804783, 2269728455, 3644379585, 2362090238, 2564033334, 2801107407, 2776292904, 3669462566, 1068351396, 742039012, 1350078989, 1784663195, 1417561698, 4136440770, 2430122216, 775550814, 2193862645, 2673705150, 1775276924, 1876241833, 3475313331, 3366754619, 270040487, 3902563182, 3678124923, 3441850377, 1851332852, 3969562369, 2203032232, 3868552805, 2868897406, 566021896, 4011190502, 3135740889, 1248802510, 3936291284, 699432150, 832877231, 708780849, 3332740144, 899835584, 1951317047, 4236429990, 3767586992, 866637845, 4043610186, 1106041591, 2144161806, 395441711, 1984812685, 1139781709, 3433712980, 3835036895, 2664543715, 1282050075, 3240894392, 1181045119, 2640243204, 25965917, 4203181171, 4211818798, 3009879386, 2463879762, 3910161971, 1842759443, 2597806476, 933301370, 1509430414, 3943906441, 3467192302, 3076639029, 3776767469, 2051518780, 2631065433, 1441952575, 404016761, 1942435775, 1408749034, 1610459739, 3745345300, 2017778566, 3400528769, 3110650942, 941896748, 3265478751, 371049330, 3168937228, 675039627, 4279080257, 967311729, 135050206, 3635733660, 1683407248, 2076935265, 3576870512, 1215061108, 3501741890], jr = [1347548327, 1400783205, 3273267108, 2520393566, 3409685355, 4045380933, 2880240216, 2471224067, 1428173050, 4138563181, 2441661558, 636813900, 4233094615, 3620022987, 2149987652, 2411029155, 1239331162, 1730525723, 2554718734, 3781033664, 46346101, 310463728, 2743944855, 3328955385, 3875770207, 2501218972, 3955191162, 3667219033, 768917123, 3545789473, 692707433, 1150208456, 1786102409, 2029293177, 1805211710, 3710368113, 3065962831, 401639597, 1724457132, 3028143674, 409198410, 2196052529, 1620529459, 1164071807, 3769721975, 2226875310, 486441376, 2499348523, 1483753576, 428819965, 2274680428, 3075636216, 598438867, 3799141122, 1474502543, 711349675, 129166120, 53458370, 2592523643, 2782082824, 4063242375, 2988687269, 3120694122, 1559041666, 730517276, 2460449204, 4042459122, 2706270690, 3446004468, 3573941694, 533804130, 2328143614, 2637442643, 2695033685, 839224033, 1973745387, 957055980, 2856345839, 106852767, 1371368976, 4181598602, 1033297158, 2933734917, 1179510461, 3046200461, 91341917, 1862534868, 4284502037, 605657339, 2547432937, 3431546947, 2003294622, 3182487618, 2282195339, 954669403, 3682191598, 1201765386, 3917234703, 3388507166, 0, 2198438022, 1211247597, 2887651696, 1315723890, 4227665663, 1443857720, 507358933, 657861945, 1678381017, 560487590, 3516619604, 975451694, 2970356327, 261314535, 3535072918, 2652609425, 1333838021, 2724322336, 1767536459, 370938394, 182621114, 3854606378, 1128014560, 487725847, 185469197, 2918353863, 3106780840, 3356761769, 2237133081, 1286567175, 3152976349, 4255350624, 2683765030, 3160175349, 3309594171, 878443390, 1988838185, 3704300486, 1756818940, 1673061617, 3403100636, 272786309, 1075025698, 545572369, 2105887268, 4174560061, 296679730, 1841768865, 1260232239, 4091327024, 3960309330, 3497509347, 1814803222, 2578018489, 4195456072, 575138148, 3299409036, 446754879, 3629546796, 4011996048, 3347532110, 3252238545, 4270639778, 915985419, 3483825537, 681933534, 651868046, 2755636671, 3828103837, 223377554, 2607439820, 1649704518, 3270937875, 3901806776, 1580087799, 4118987695, 3198115200, 2087309459, 2842678573, 3016697106, 1003007129, 2802849917, 1860738147, 2077965243, 164439672, 4100872472, 32283319, 2827177882, 1709610350, 2125135846, 136428751, 3874428392, 3652904859, 3460984630, 3572145929, 3593056380, 2939266226, 824852259, 818324884, 3224740454, 930369212, 2801566410, 2967507152, 355706840, 1257309336, 4148292826, 243256656, 790073846, 2373340630, 1296297904, 1422699085, 3756299780, 3818836405, 457992840, 3099667487, 2135319889, 77422314, 1560382517, 1945798516, 788204353, 1521706781, 1385356242, 870912086, 325965383, 2358957921, 2050466060, 2388260884, 2313884476, 4006521127, 901210569, 3990953189, 1014646705, 1503449823, 1062597235, 2031621326, 3212035895, 3931371469, 1533017514, 350174575, 2256028891, 2177544179, 1052338372, 741876788, 1606591296, 1914052035, 213705253, 2334669897, 1107234197, 1899603969, 3725069491, 2631447780, 2422494913, 1635502980, 1893020342, 1950903388, 1120974935], Mr = [2807058932, 1699970625, 2764249623, 1586903591, 1808481195, 1173430173, 1487645946, 59984867, 4199882800, 1844882806, 1989249228, 1277555970, 3623636965, 3419915562, 1149249077, 2744104290, 1514790577, 459744698, 244860394, 3235995134, 1963115311, 4027744588, 2544078150, 4190530515, 1608975247, 2627016082, 2062270317, 1507497298, 2200818878, 567498868, 1764313568, 3359936201, 2305455554, 2037970062, 1047239e3, 1910319033, 1337376481, 2904027272, 2892417312, 984907214, 1243112415, 830661914, 861968209, 2135253587, 2011214180, 2927934315, 2686254721, 731183368, 1750626376, 4246310725, 1820824798, 4172763771, 3542330227, 48394827, 2404901663, 2871682645, 671593195, 3254988725, 2073724613, 145085239, 2280796200, 2779915199, 1790575107, 2187128086, 472615631, 3029510009, 4075877127, 3802222185, 4107101658, 3201631749, 1646252340, 4270507174, 1402811438, 1436590835, 3778151818, 3950355702, 3963161475, 4020912224, 2667994737, 273792366, 2331590177, 104699613, 95345982, 3175501286, 2377486676, 1560637892, 3564045318, 369057872, 4213447064, 3919042237, 1137477952, 2658625497, 1119727848, 2340947849, 1530455833, 4007360968, 172466556, 266959938, 516552836, 0, 2256734592, 3980931627, 1890328081, 1917742170, 4294704398, 945164165, 3575528878, 958871085, 3647212047, 2787207260, 1423022939, 775562294, 1739656202, 3876557655, 2530391278, 2443058075, 3310321856, 547512796, 1265195639, 437656594, 3121275539, 719700128, 3762502690, 387781147, 218828297, 3350065803, 2830708150, 2848461854, 428169201, 122466165, 3720081049, 1627235199, 648017665, 4122762354, 1002783846, 2117360635, 695634755, 3336358691, 4234721005, 4049844452, 3704280881, 2232435299, 574624663, 287343814, 612205898, 1039717051, 840019705, 2708326185, 793451934, 821288114, 1391201670, 3822090177, 376187827, 3113855344, 1224348052, 1679968233, 2361698556, 1058709744, 752375421, 2431590963, 1321699145, 3519142200, 2734591178, 188127444, 2177869557, 3727205754, 2384911031, 3215212461, 2648976442, 2450346104, 3432737375, 1180849278, 331544205, 3102249176, 4150144569, 2952102595, 2159976285, 2474404304, 766078933, 313773861, 2570832044, 2108100632, 1668212892, 3145456443, 2013908262, 418672217, 3070356634, 2594734927, 1852171925, 3867060991, 3473416636, 3907448597, 2614737639, 919489135, 164948639, 2094410160, 2997825956, 590424639, 2486224549, 1723872674, 3157750862, 3399941250, 3501252752, 3625268135, 2555048196, 3673637356, 1343127501, 4130281361, 3599595085, 2957853679, 1297403050, 81781910, 3051593425, 2283490410, 532201772, 1367295589, 3926170974, 895287692, 1953757831, 1093597963, 492483431, 3528626907, 1446242576, 1192455638, 1636604631, 209336225, 344873464, 1015671571, 669961897, 3375740769, 3857572124, 2973530695, 3747192018, 1933530610, 3464042516, 935293895, 3454686199, 2858115069, 1863638845, 3683022916, 4085369519, 3292445032, 875313188, 1080017571, 3279033885, 621591778, 1233856572, 2504130317, 24197544, 3017672716, 3835484340, 3247465558, 2220981195, 3060847922, 1551124588, 1463996600], qr = [4104605777, 1097159550, 396673818, 660510266, 2875968315, 2638606623, 4200115116, 3808662347, 821712160, 1986918061, 3430322568, 38544885, 3856137295, 718002117, 893681702, 1654886325, 2975484382, 3122358053, 3926825029, 4274053469, 796197571, 1290801793, 1184342925, 3556361835, 2405426947, 2459735317, 1836772287, 1381620373, 3196267988, 1948373848, 3764988233, 3385345166, 3263785589, 2390325492, 1480485785, 3111247143, 3780097726, 2293045232, 548169417, 3459953789, 3746175075, 439452389, 1362321559, 1400849762, 1685577905, 1806599355, 2174754046, 137073913, 1214797936, 1174215055, 3731654548, 2079897426, 1943217067, 1258480242, 529487843, 1437280870, 3945269170, 3049390895, 3313212038, 923313619, 679998e3, 3215307299, 57326082, 377642221, 3474729866, 2041877159, 133361907, 1776460110, 3673476453, 96392454, 878845905, 2801699524, 777231668, 4082475170, 2330014213, 4142626212, 2213296395, 1626319424, 1906247262, 1846563261, 562755902, 3708173718, 1040559837, 3871163981, 1418573201, 3294430577, 114585348, 1343618912, 2566595609, 3186202582, 1078185097, 3651041127, 3896688048, 2307622919, 425408743, 3371096953, 2081048481, 1108339068, 2216610296, 0, 2156299017, 736970802, 292596766, 1517440620, 251657213, 2235061775, 2933202493, 758720310, 265905162, 1554391400, 1532285339, 908999204, 174567692, 1474760595, 4002861748, 2610011675, 3234156416, 3693126241, 2001430874, 303699484, 2478443234, 2687165888, 585122620, 454499602, 151849742, 2345119218, 3064510765, 514443284, 4044981591, 1963412655, 2581445614, 2137062819, 19308535, 1928707164, 1715193156, 4219352155, 1126790795, 600235211, 3992742070, 3841024952, 836553431, 1669664834, 2535604243, 3323011204, 1243905413, 3141400786, 4180808110, 698445255, 2653899549, 2989552604, 2253581325, 3252932727, 3004591147, 1891211689, 2487810577, 3915653703, 4237083816, 4030667424, 2100090966, 865136418, 1229899655, 953270745, 3399679628, 3557504664, 4118925222, 2061379749, 3079546586, 2915017791, 983426092, 2022837584, 1607244650, 2118541908, 2366882550, 3635996816, 972512814, 3283088770, 1568718495, 3499326569, 3576539503, 621982671, 2895723464, 410887952, 2623762152, 1002142683, 645401037, 1494807662, 2595684844, 1335535747, 2507040230, 4293295786, 3167684641, 367585007, 3885750714, 1865862730, 2668221674, 2960971305, 2763173681, 1059270954, 2777952454, 2724642869, 1320957812, 2194319100, 2429595872, 2815956275, 77089521, 3973773121, 3444575871, 2448830231, 1305906550, 4021308739, 2857194700, 2516901860, 3518358430, 1787304780, 740276417, 1699839814, 1592394909, 2352307457, 2272556026, 188821243, 1729977011, 3687994002, 274084841, 3594982253, 3613494426, 2701949495, 4162096729, 322734571, 2837966542, 1640576439, 484830689, 1202797690, 3537852828, 4067639125, 349075736, 3342319475, 4157467219, 4255800159, 1030690015, 1155237496, 2951971274, 1757691577, 607398968, 2738905026, 499347990, 3794078908, 1011452712, 227885567, 2818666809, 213114376, 3034881240, 1455525988, 3414450555, 850817237, 1817998408, 3092726480], Wr = [0, 235474187, 470948374, 303765277, 941896748, 908933415, 607530554, 708780849, 1883793496, 2118214995, 1817866830, 1649639237, 1215061108, 1181045119, 1417561698, 1517767529, 3767586992, 4003061179, 4236429990, 4069246893, 3635733660, 3602770327, 3299278474, 3400528769, 2430122216, 2664543715, 2362090238, 2193862645, 2835123396, 2801107407, 3035535058, 3135740889, 3678124923, 3576870512, 3341394285, 3374361702, 3810496343, 3977675356, 4279080257, 4043610186, 2876494627, 2776292904, 3076639029, 3110650942, 2472011535, 2640243204, 2403728665, 2169303058, 1001089995, 899835584, 666464733, 699432150, 59727847, 226906860, 530400753, 294930682, 1273168787, 1172967064, 1475418501, 1509430414, 1942435775, 2110667444, 1876241833, 1641816226, 2910219766, 2743034109, 2976151520, 3211623147, 2505202138, 2606453969, 2302690252, 2269728455, 3711829422, 3543599269, 3240894392, 3475313331, 3843699074, 3943906441, 4178062228, 4144047775, 1306967366, 1139781709, 1374988112, 1610459739, 1975683434, 2076935265, 1775276924, 1742315127, 1034867998, 866637845, 566021896, 800440835, 92987698, 193195065, 429456164, 395441711, 1984812685, 2017778566, 1784663195, 1683407248, 1315562145, 1080094634, 1383856311, 1551037884, 101039829, 135050206, 437757123, 337553864, 1042385657, 807962610, 573804783, 742039012, 2531067453, 2564033334, 2328828971, 2227573024, 2935566865, 2700099354, 3001755655, 3168937228, 3868552805, 3902563182, 4203181171, 4102977912, 3736164937, 3501741890, 3265478751, 3433712980, 1106041591, 1340463100, 1576976609, 1408749034, 2043211483, 2009195472, 1708848333, 1809054150, 832877231, 1068351396, 766945465, 599762354, 159417987, 126454664, 361929877, 463180190, 2709260871, 2943682380, 3178106961, 3009879386, 2572697195, 2538681184, 2236228733, 2336434550, 3509871135, 3745345300, 3441850377, 3274667266, 3910161971, 3877198648, 4110568485, 4211818798, 2597806476, 2497604743, 2261089178, 2295101073, 2733856160, 2902087851, 3202437046, 2968011453, 3936291284, 3835036895, 4136440770, 4169408201, 3535486456, 3702665459, 3467192302, 3231722213, 2051518780, 1951317047, 1716890410, 1750902305, 1113818384, 1282050075, 1584504582, 1350078989, 168810852, 67556463, 371049330, 404016761, 841739592, 1008918595, 775550814, 540080725, 3969562369, 3801332234, 4035489047, 4269907996, 3569255213, 3669462566, 3366754619, 3332740144, 2631065433, 2463879762, 2160117071, 2395588676, 2767645557, 2868897406, 3102011747, 3069049960, 202008497, 33778362, 270040487, 504459436, 875451293, 975658646, 675039627, 641025152, 2084704233, 1917518562, 1615861247, 1851332852, 1147550661, 1248802510, 1484005843, 1451044056, 933301370, 967311729, 733156972, 632953703, 260388950, 25965917, 328671808, 496906059, 1206477858, 1239443753, 1543208500, 1441952575, 2144161806, 1908694277, 1675577880, 1842759443, 3610369226, 3644379585, 3408119516, 3307916247, 4011190502, 3776767469, 4077384432, 4245618683, 2809771154, 2842737049, 3144396420, 3043140495, 2673705150, 2438237621, 2203032232, 2370213795], zr = [0, 185469197, 370938394, 487725847, 741876788, 657861945, 975451694, 824852259, 1483753576, 1400783205, 1315723890, 1164071807, 1950903388, 2135319889, 1649704518, 1767536459, 2967507152, 3152976349, 2801566410, 2918353863, 2631447780, 2547432937, 2328143614, 2177544179, 3901806776, 3818836405, 4270639778, 4118987695, 3299409036, 3483825537, 3535072918, 3652904859, 2077965243, 1893020342, 1841768865, 1724457132, 1474502543, 1559041666, 1107234197, 1257309336, 598438867, 681933534, 901210569, 1052338372, 261314535, 77422314, 428819965, 310463728, 3409685355, 3224740454, 3710368113, 3593056380, 3875770207, 3960309330, 4045380933, 4195456072, 2471224067, 2554718734, 2237133081, 2388260884, 3212035895, 3028143674, 2842678573, 2724322336, 4138563181, 4255350624, 3769721975, 3955191162, 3667219033, 3516619604, 3431546947, 3347532110, 2933734917, 2782082824, 3099667487, 3016697106, 2196052529, 2313884476, 2499348523, 2683765030, 1179510461, 1296297904, 1347548327, 1533017514, 1786102409, 1635502980, 2087309459, 2003294622, 507358933, 355706840, 136428751, 53458370, 839224033, 957055980, 605657339, 790073846, 2373340630, 2256028891, 2607439820, 2422494913, 2706270690, 2856345839, 3075636216, 3160175349, 3573941694, 3725069491, 3273267108, 3356761769, 4181598602, 4063242375, 4011996048, 3828103837, 1033297158, 915985419, 730517276, 545572369, 296679730, 446754879, 129166120, 213705253, 1709610350, 1860738147, 1945798516, 2029293177, 1239331162, 1120974935, 1606591296, 1422699085, 4148292826, 4233094615, 3781033664, 3931371469, 3682191598, 3497509347, 3446004468, 3328955385, 2939266226, 2755636671, 3106780840, 2988687269, 2198438022, 2282195339, 2501218972, 2652609425, 1201765386, 1286567175, 1371368976, 1521706781, 1805211710, 1620529459, 2105887268, 1988838185, 533804130, 350174575, 164439672, 46346101, 870912086, 954669403, 636813900, 788204353, 2358957921, 2274680428, 2592523643, 2441661558, 2695033685, 2880240216, 3065962831, 3182487618, 3572145929, 3756299780, 3270937875, 3388507166, 4174560061, 4091327024, 4006521127, 3854606378, 1014646705, 930369212, 711349675, 560487590, 272786309, 457992840, 106852767, 223377554, 1678381017, 1862534868, 1914052035, 2031621326, 1211247597, 1128014560, 1580087799, 1428173050, 32283319, 182621114, 401639597, 486441376, 768917123, 651868046, 1003007129, 818324884, 1503449823, 1385356242, 1333838021, 1150208456, 1973745387, 2125135846, 1673061617, 1756818940, 2970356327, 3120694122, 2802849917, 2887651696, 2637442643, 2520393566, 2334669897, 2149987652, 3917234703, 3799141122, 4284502037, 4100872472, 3309594171, 3460984630, 3545789473, 3629546796, 2050466060, 1899603969, 1814803222, 1730525723, 1443857720, 1560382517, 1075025698, 1260232239, 575138148, 692707433, 878443390, 1062597235, 243256656, 91341917, 409198410, 325965383, 3403100636, 3252238545, 3704300486, 3620022987, 3874428392, 3990953189, 4042459122, 4227665663, 2460449204, 2578018489, 2226875310, 2411029155, 3198115200, 3046200461, 2827177882, 2743944855], Zr = [0, 218828297, 437656594, 387781147, 875313188, 958871085, 775562294, 590424639, 1750626376, 1699970625, 1917742170, 2135253587, 1551124588, 1367295589, 1180849278, 1265195639, 3501252752, 3720081049, 3399941250, 3350065803, 3835484340, 3919042237, 4270507174, 4085369519, 3102249176, 3051593425, 2734591178, 2952102595, 2361698556, 2177869557, 2530391278, 2614737639, 3145456443, 3060847922, 2708326185, 2892417312, 2404901663, 2187128086, 2504130317, 2555048196, 3542330227, 3727205754, 3375740769, 3292445032, 3876557655, 3926170974, 4246310725, 4027744588, 1808481195, 1723872674, 1910319033, 2094410160, 1608975247, 1391201670, 1173430173, 1224348052, 59984867, 244860394, 428169201, 344873464, 935293895, 984907214, 766078933, 547512796, 1844882806, 1627235199, 2011214180, 2062270317, 1507497298, 1423022939, 1137477952, 1321699145, 95345982, 145085239, 532201772, 313773861, 830661914, 1015671571, 731183368, 648017665, 3175501286, 2957853679, 2807058932, 2858115069, 2305455554, 2220981195, 2474404304, 2658625497, 3575528878, 3625268135, 3473416636, 3254988725, 3778151818, 3963161475, 4213447064, 4130281361, 3599595085, 3683022916, 3432737375, 3247465558, 3802222185, 4020912224, 4172763771, 4122762354, 3201631749, 3017672716, 2764249623, 2848461854, 2331590177, 2280796200, 2431590963, 2648976442, 104699613, 188127444, 472615631, 287343814, 840019705, 1058709744, 671593195, 621591778, 1852171925, 1668212892, 1953757831, 2037970062, 1514790577, 1463996600, 1080017571, 1297403050, 3673637356, 3623636965, 3235995134, 3454686199, 4007360968, 3822090177, 4107101658, 4190530515, 2997825956, 3215212461, 2830708150, 2779915199, 2256734592, 2340947849, 2627016082, 2443058075, 172466556, 122466165, 273792366, 492483431, 1047239e3, 861968209, 612205898, 695634755, 1646252340, 1863638845, 2013908262, 1963115311, 1446242576, 1530455833, 1277555970, 1093597963, 1636604631, 1820824798, 2073724613, 1989249228, 1436590835, 1487645946, 1337376481, 1119727848, 164948639, 81781910, 331544205, 516552836, 1039717051, 821288114, 669961897, 719700128, 2973530695, 3157750862, 2871682645, 2787207260, 2232435299, 2283490410, 2667994737, 2450346104, 3647212047, 3564045318, 3279033885, 3464042516, 3980931627, 3762502690, 4150144569, 4199882800, 3070356634, 3121275539, 2904027272, 2686254721, 2200818878, 2384911031, 2570832044, 2486224549, 3747192018, 3528626907, 3310321856, 3359936201, 3950355702, 3867060991, 4049844452, 4234721005, 1739656202, 1790575107, 2108100632, 1890328081, 1402811438, 1586903591, 1233856572, 1149249077, 266959938, 48394827, 369057872, 418672217, 1002783846, 919489135, 567498868, 752375421, 209336225, 24197544, 376187827, 459744698, 945164165, 895287692, 574624663, 793451934, 1679968233, 1764313568, 2117360635, 1933530610, 1343127501, 1560637892, 1243112415, 1192455638, 3704280881, 3519142200, 3336358691, 3419915562, 3907448597, 3857572124, 4075877127, 4294704398, 3029510009, 3113855344, 2927934315, 2744104290, 2159976285, 2377486676, 2594734927, 2544078150], Hr = [0, 151849742, 303699484, 454499602, 607398968, 758720310, 908999204, 1059270954, 1214797936, 1097159550, 1517440620, 1400849762, 1817998408, 1699839814, 2118541908, 2001430874, 2429595872, 2581445614, 2194319100, 2345119218, 3034881240, 3186202582, 2801699524, 2951971274, 3635996816, 3518358430, 3399679628, 3283088770, 4237083816, 4118925222, 4002861748, 3885750714, 1002142683, 850817237, 698445255, 548169417, 529487843, 377642221, 227885567, 77089521, 1943217067, 2061379749, 1640576439, 1757691577, 1474760595, 1592394909, 1174215055, 1290801793, 2875968315, 2724642869, 3111247143, 2960971305, 2405426947, 2253581325, 2638606623, 2487810577, 3808662347, 3926825029, 4044981591, 4162096729, 3342319475, 3459953789, 3576539503, 3693126241, 1986918061, 2137062819, 1685577905, 1836772287, 1381620373, 1532285339, 1078185097, 1229899655, 1040559837, 923313619, 740276417, 621982671, 439452389, 322734571, 137073913, 19308535, 3871163981, 4021308739, 4104605777, 4255800159, 3263785589, 3414450555, 3499326569, 3651041127, 2933202493, 2815956275, 3167684641, 3049390895, 2330014213, 2213296395, 2566595609, 2448830231, 1305906550, 1155237496, 1607244650, 1455525988, 1776460110, 1626319424, 2079897426, 1928707164, 96392454, 213114376, 396673818, 514443284, 562755902, 679998e3, 865136418, 983426092, 3708173718, 3557504664, 3474729866, 3323011204, 4180808110, 4030667424, 3945269170, 3794078908, 2507040230, 2623762152, 2272556026, 2390325492, 2975484382, 3092726480, 2738905026, 2857194700, 3973773121, 3856137295, 4274053469, 4157467219, 3371096953, 3252932727, 3673476453, 3556361835, 2763173681, 2915017791, 3064510765, 3215307299, 2156299017, 2307622919, 2459735317, 2610011675, 2081048481, 1963412655, 1846563261, 1729977011, 1480485785, 1362321559, 1243905413, 1126790795, 878845905, 1030690015, 645401037, 796197571, 274084841, 425408743, 38544885, 188821243, 3613494426, 3731654548, 3313212038, 3430322568, 4082475170, 4200115116, 3780097726, 3896688048, 2668221674, 2516901860, 2366882550, 2216610296, 3141400786, 2989552604, 2837966542, 2687165888, 1202797690, 1320957812, 1437280870, 1554391400, 1669664834, 1787304780, 1906247262, 2022837584, 265905162, 114585348, 499347990, 349075736, 736970802, 585122620, 972512814, 821712160, 2595684844, 2478443234, 2293045232, 2174754046, 3196267988, 3079546586, 2895723464, 2777952454, 3537852828, 3687994002, 3234156416, 3385345166, 4142626212, 4293295786, 3841024952, 3992742070, 174567692, 57326082, 410887952, 292596766, 777231668, 660510266, 1011452712, 893681702, 1108339068, 1258480242, 1343618912, 1494807662, 1715193156, 1865862730, 1948373848, 2100090966, 2701949495, 2818666809, 3004591147, 3122358053, 2235061775, 2352307457, 2535604243, 2653899549, 3915653703, 3764988233, 4219352155, 4067639125, 3444575871, 3294430577, 3746175075, 3594982253, 836553431, 953270745, 600235211, 718002117, 367585007, 484830689, 133361907, 251657213, 2041877159, 1891211689, 1806599355, 1654886325, 1568718495, 1418573201, 1335535747, 1184342925];
function D0(e) {
  return parseInt("".concat(e)) === e;
}
function f1(e) {
  if (!D0(e.length)) return !1;
  for (var t = 0; t < e.length; t++) if (!D0(e[t]) || e[t] < 0 || e[t] > 255) return !1;
  return !0;
}
function A2(e) {
  return new Uint8Array(e);
}
function B0(e) {
  for (var t = [], i = 0; i < e.length; i += 4) t.push(e[i] << 24 | e[i + 1] << 16 | e[i + 2] << 8 | e[i + 3]);
  return t;
}
function c0(e, t) {
  if (e.buffer && e.name === "Uint8Array") return t && (e.slice ? e = e.slice() : e = Array.prototype.slice.call(e)), e;
  if (Array.isArray(e)) {
    if (!f1(e)) throw new Error("Array contains invalid value");
    return new Uint8Array(e);
  }
  if (D0(e.length) && f1(e)) return new Uint8Array(e);
  throw new Error("unsupported array-like object");
}
function a0(e, t, i, a, o) {
  (a != null || o != null) && (e.slice ? e = e.slice(a, o) : e = Array.prototype.slice.call(e, a, o)), t.set(e, i);
}
var Kr = function() {
  function e(t) {
    g0(this, e), H(this, "key"), H(this, "_Ke"), H(this, "_Kd"), this.key = c0(t, !0), this._prepare();
  }
  return T0(e, [{ key: "_prepare", value: function() {
    var i = Or[this.key.length];
    if (i == null) throw new Error("invalid key size (must be 16, 24 or 32 bytes)");
    this._Ke = [], this._Kd = [];
    for (var a = 0; a <= i; a++) this._Ke.push([0, 0, 0, 0]), this._Kd.push([0, 0, 0, 0]);
    for (var o = (i + 1) * 4, s = this.key.length / 4, f = B0(this.key), p, d = 0; d < s; d++) p = d >> 2, this._Ke[p][d % 4] = f[d], this._Kd[i - p][d % 4] = f[d];
    for (var l = 0, u = s, b; u < o; ) {
      if (b = f[s - 1], f[0] ^= z[b >> 16 & 255] << 24 ^ z[b >> 8 & 255] << 16 ^ z[b & 255] << 8 ^ z[b >> 24 & 255] ^ Rr[l] << 24, l += 1, s != 8) for (var x = 1; x < s; x++) f[x] ^= f[x - 1];
      else {
        for (var w = 1; w < s / 2; w++) f[w] ^= f[w - 1];
        b = f[s / 2 - 1], f[s / 2] ^= z[b & 255] ^ z[b >> 8 & 255] << 8 ^ z[b >> 16 & 255] << 16 ^ z[b >> 24 & 255] << 24;
        for (var v = s / 2 + 1; v < s; v++) f[v] ^= f[v - 1];
      }
      for (var C = 0, B = void 0, F = void 0; C < s && u < o; ) B = u >> 2, F = u % 4, this._Ke[B][F] = f[C], this._Kd[i - B][F] = f[C++], u++;
    }
    for (var I = 1; I < i; I++) for (var S = 0; S < 4; S++) b = this._Kd[I][S], this._Kd[I][S] = Wr[b >> 24 & 255] ^ zr[b >> 16 & 255] ^ Zr[b >> 8 & 255] ^ Hr[b & 255];
  } }, { key: "encrypt", value: function(t) {
    if (t.length != 16) throw new Error("invalid plaintext size (must be 16 bytes)");
    for (var i = this._Ke.length - 1, a = [0, 0, 0, 0], o = B0(t), s = 0; s < 4; s++) o[s] ^= this._Ke[0][s];
    for (var f = 1; f < i; f++) {
      for (var p = 0; p < 4; p++) a[p] = Dr[o[p] >> 24 & 255] ^ Lr[o[(p + 1) % 4] >> 16 & 255] ^ $r[o[(p + 2) % 4] >> 8 & 255] ^ Nr[o[(p + 3) % 4] & 255] ^ this._Ke[f][p];
      o = a.slice();
    }
    for (var d = A2(16), l, u = 0; u < 4; u++) l = this._Ke[i][u], d[4 * u] = (z[o[u] >> 24 & 255] ^ l >> 24) & 255, d[4 * u + 1] = (z[o[(u + 1) % 4] >> 16 & 255] ^ l >> 16) & 255, d[4 * u + 2] = (z[o[(u + 2) % 4] >> 8 & 255] ^ l >> 8) & 255, d[4 * u + 3] = (z[o[(u + 3) % 4] & 255] ^ l) & 255;
    return d;
  } }, { key: "decrypt", value: function(t) {
    if (t.length != 16) throw new Error("invalid ciphertext size (must be 16 bytes)");
    for (var i = this._Kd.length - 1, a = [0, 0, 0, 0], o = B0(t), s = 0; s < 4; s++) o[s] ^= this._Kd[0][s];
    for (var f = 1; f < i; f++) {
      for (var p = 0; p < 4; p++) a[p] = Tr[o[p] >> 24 & 255] ^ jr[o[(p + 3) % 4] >> 16 & 255] ^ Mr[o[(p + 2) % 4] >> 8 & 255] ^ qr[o[(p + 1) % 4] & 255] ^ this._Kd[f][p];
      o = a.slice();
    }
    for (var d = A2(16), l, u = 0; u < 4; u++) l = this._Kd[i][u], d[4 * u] = (o0[o[u] >> 24 & 255] ^ l >> 24) & 255, d[4 * u + 1] = (o0[o[(u + 3) % 4] >> 16 & 255] ^ l >> 16) & 255, d[4 * u + 2] = (o0[o[(u + 2) % 4] >> 8 & 255] ^ l >> 8) & 255, d[4 * u + 3] = (o0[o[(u + 1) % 4] & 255] ^ l) & 255;
    return d;
  } }]), e;
}(), Z1 = function() {
  function e(t, i) {
    if (g0(this, e), H(this, "_aes"), H(this, "_lastCipherblock"), !i) i = new Uint8Array(16);
    else if (i.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
    this._lastCipherblock = c0(i, !0), this._aes = new Kr(t);
  }
  return T0(e, [{ key: "encrypt", value: function(t) {
    if (t = c0(t), t.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
    for (var i = A2(t.length), a = A2(16), o = 0; o < t.length; o += 16) {
      a0(t, a, 0, o, o + 16);
      for (var s = 0; s < 16; s++) a[s] ^= this._lastCipherblock[s];
      this._lastCipherblock = this._aes.encrypt(a), a0(this._lastCipherblock, i, o);
    }
    return i;
  } }, { key: "decrypt", value: function(t) {
    if (t = c0(t), t.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
    for (var i = A2(t.length), a = A2(16), o = 0; o < t.length; o += 16) {
      a0(t, a, 0, o, o + 16), a = this._aes.decrypt(a);
      for (var s = 0; s < 16; s++) i[o + s] = a[s] ^ this._lastCipherblock[s];
      a0(t, this._lastCipherblock, 0, o, o + 16);
    }
    return i;
  } }]), e;
}(), Gr = [[16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16], [15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15], [14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14], [13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13], [12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12], [11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11], [10, 10, 10, 10, 10, 10, 10, 10, 10, 10], [9, 9, 9, 9, 9, 9, 9, 9, 9], [8, 8, 8, 8, 8, 8, 8, 8], [7, 7, 7, 7, 7, 7, 7], [6, 6, 6, 6, 6, 6], [5, 5, 5, 5, 5], [4, 4, 4, 4], [3, 3, 3], [2, 2], [1]], H1 = { pad: function(e) {
  var t = Gr[e.byteLength % 16 || 0], i = new Uint8Array(e.byteLength + t.length);
  return i.set(e), i.set(t, e.byteLength), i;
}, unpad: function(e) {
  return e.subarray(0, e.byteLength - e[e.byteLength - 1]);
} }, Vr = "sha256";
function Jr(e, t, i) {
  var a = new Z1(t, e), o = H1.pad(i), s = a.encrypt(o);
  return new Uint8Array(s);
}
function Yr(e, t, i) {
  var a = new Z1(t, e).decrypt(i), o = new Uint8Array(a);
  return H1.unpad(o);
}
function K1(e, t) {
  var i = d0.hmac(P3[Vr], e).update(t).digest("hex");
  return x2(i);
}
function Xr(e) {
  for (var t = new Uint8Array(e), i = 0; i < e; ++i) t[i] = Math.floor(256 * Math.random());
  return Y2(t);
}
function Qr(e) {
  var t = Xr(e);
  return y2(t);
}
function en(e) {
  var t = (e || 256) / 8, i = Qr(t);
  return Pr(Y2(i));
}
function tn(e, t) {
  var i = x2(e.data), a = x2(e.iv), o = x2(e.hmac), s = S2(o, !1), f = z1(i, a), p = K1(t, f), d = S2(p, !1);
  return O0(s) === O0(d);
}
function zn(e, t, i) {
  var a = y2(R0(t)), o = en(128), s = y2(R0(o)), f = S2(s, !1), p = JSON.stringify(e), d = Sr(p), l = Jr(s, a, d), u = S2(l, !1), b = z1(l, s), x = K1(a, b), w = S2(x, !1);
  return { data: u, hmac: w, iv: f };
}
function Zn(e, t) {
  var i = y2(R0(t));
  if (!i) throw new Error("Missing key: required for decryption");
  if (!tn(e, i)) return null;
  var a = x2(e.data), o = x2(e.iv), s = Yr(o, i, a), f = kr(s), p;
  try {
    p = JSON.parse(f);
  } catch {
    return null;
  }
  return p;
}
function Hn(e) {
  var t = null;
  try {
    var i = window.localStorage.getItem(e);
    i && (t = JSON.parse(i));
  } catch {
    t = null;
  }
  return t;
}
function Kn(e) {
  try {
    window.localStorage.removeItem(e);
  } catch {
  }
}
function Gn(e, t) {
  try {
    window.localStorage.setItem(e, JSON.stringify(t));
  } catch {
  }
}
var Vn = function e() {
  var t = this;
  g0(this, e), H(this, "events", new pe()), H(this, "on", function(i, a) {
    return t.events.on(i, a);
  }), H(this, "once", function(i, a) {
    return t.events.once(i, a);
  }), H(this, "off", function(i, a) {
    return t.events.off(i, a);
  }), H(this, "removeListener", function(i, a) {
    return t.events.removeListener(i, a);
  }), H(this, "removeAllListeners", function() {
    return t.events.removeAllListeners();
  });
}, Jn = { error: function() {
  for (var t = arguments.length, i = new Array(t), a = 0; a < t; a++)
    i[a] = arguments[a];
  var o;
  (o = console).error.apply(o, ["[ERROR]"].concat(Z2(i)));
}, warn: function() {
  for (var t = arguments.length, i = new Array(t), a = 0; a < t; a++)
    i[a] = arguments[a];
  var o;
  (o = console).warn.apply(o, ["[WARN]"].concat(Z2(i)));
}, info: function() {
  for (var t = arguments.length, i = new Array(t), a = 0; a < t; a++)
    i[a] = arguments[a];
  var o;
  (o = console).info.apply(o, ["[INFO]"].concat(Z2(i)));
}, debug: function() {
  for (var t = arguments.length, i = new Array(t), a = 0; a < t; a++)
    i[a] = arguments[a];
  var o;
  (o = console).log.apply(o, ["[DEBUG]"].concat(Z2(i)));
} }, rn = (typeof window > "u" ? "undefined" : K(window)) < "u";
function nn() {
  for (var e = document.getElementsByTagName("link"), t = [], i = 0; i < e.length; i++) {
    var a = e[i], o = a.getAttribute("rel");
    if (o && o.toLowerCase().indexOf("icon") > -1) {
      var s = a.getAttribute("href");
      if (s) if (s.toLowerCase().indexOf("https:") === -1 && s.toLowerCase().indexOf("http:") === -1 && s.indexOf("//") !== 0) {
        var f = location.protocol + "//" + location.host;
        if (s.indexOf("/") === 0) f += s;
        else {
          var p = location.pathname.split("/");
          p.pop();
          var d = p.join("/");
          f += d + "/" + s;
        }
        t.push(f);
      } else if (s.indexOf("//") === 0) {
        var l = location.protocol + s;
        t.push(l);
      } else t.push(s);
    }
  }
  return t;
}
function G1() {
  for (var e = function(p) {
    var d = o[p], l = ["itemprop", "property", "name"].map(function(b) {
      return d.getAttribute(b);
    }).filter(function(b) {
      return b ? i.includes(b) : !1;
    });
    if (l.length && l) {
      var u = d.getAttribute("content");
      if (u) return { v: u };
    }
  }, t = arguments.length, i = new Array(t), a = 0; a < t; a++)
    i[a] = arguments[a];
  for (var o = document.getElementsByTagName("meta"), s = 0; s < o.length; s++) {
    var f = e(s);
    if (K(f) === "object") return f.v;
  }
  return "";
}
function on() {
  var e = G1("name", "og:site_name", "og:title", "twitter:title");
  return e || (e = document.title), e;
}
function an() {
  return G1("description", "og:description", "twitter:description", "keywords");
}
function Yn() {
  if (rn) {
    var e = on(), t = an(), i = location.origin, a = nn();
    return { description: t, url: i, icons: a, name: e };
  }
}
var Xn = function(e) {
  Q3(i, e);
  var t = ur(i);
  function i(a, o) {
    g0(this, i);
    var s;
    return s = t.call(this, o), H(k0(s), "code"), s.code = a, Object.setPrototypeOf(k0(s), (er(this, i) ? this.constructor : void 0).prototype), s;
  }
  return T0(i, [{ key: "toString", value: function() {
    return "".concat(this.message, " (").concat(this.code, ")");
  } }]), i;
}(P0(Error)), Qn = { CLOSE_MODAL: { code: 100001, message: "[binance-w3w] User closed modal" }, REJECT_SESSION: { code: 100002, message: "[binance-w3w] User rejected connection" }, PROVIDER_NOT_READY: { code: 100003, message: "[binance-w3w] Provider is not ready" }, CONNECTING: { code: 100004, message: "[binance-w3w] Already processing session request. Please wait" }, CONNECTED: { code: 100005, message: "[binance-w3w] Already connected" } }, e4 = { REJECT_ERR: { code: 200001, message: "[binance-w3w] User rejected the operation" }, METHOD_NOT_SUPPORT: { code: 200002, message: "[binance-w3w] Does not support calling method" }, MISSING_RESPONSE: { code: 200003, message: "[binance-w3w] Missing JSON RPC response" }, INVALID_PARAM: { code: 200004, message: "[binance-w3w] Invalid request param" } }, t4 = { INTERNAL_ERR: { code: 300001, message: "[binance-w3w] Internal error" } }, sn = function() {
  return !!(K(window.navigator) > "u" ? "" : navigator.userAgent).match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i);
}, r4 = function() {
  return !!navigator.userAgent.match(/Android/i);
}, cn = function(e, t) {
  var i = "appId=xoqXxUSMRccLCrZNRebmzj&startPagePath=L3BhZ2VzL2Rhc2hib2FyZC1uZXcvaW5kZXg=";
  if (t) {
    var a = u1("wc=".concat(encodeURIComponent(t), "&isDeepLink=true&id=").concat(+/* @__PURE__ */ new Date()));
    i = "".concat(i, "&startPageQuery=").concat(a);
  }
  var o = "//app.binance.com";
  return e ? "bnc:".concat(o, "/mp/app?").concat(i) : "https:".concat(o, "/?_dp=").concat(u1("/mp/app?".concat(i)));
}, n4 = function(e) {
  var t = sn(), i = cn(!0, e);
  if (t) {
    var a = document.createElement("a");
    a.href = i, document.body.appendChild(a), a.click(), document.body.removeChild(a);
  }
}, un = function() {
  try {
    var e, t;
    return ((t = window) === null || t === void 0 || (e = t.ethereum) === null || e === void 0 ? void 0 : e.isBinance) === !0;
  } catch {
    return !1;
  }
};
const hn = "2.11.2", fn = () => `@wagmi/core@${hn}`;
var V1 = function(e, t, i, a) {
  if (i === "a" && !a) throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !a : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return i === "m" ? a : i === "a" ? a.call(e) : a ? a.value : t.get(e);
}, h0, J1;
class V2 extends Error {
  get docsBaseUrl() {
    return "https://wagmi.sh/core";
  }
  get version() {
    return fn();
  }
  constructor(t, i = {}) {
    super(), h0.add(this), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WagmiCoreError"
    });
    const a = i.cause instanceof V2 ? i.cause.details : i.cause?.message ? i.cause.message : i.details, o = i.cause instanceof V2 && i.cause.docsPath || i.docsPath;
    this.message = [
      t || "An error occurred.",
      "",
      ...i.metaMessages ? [...i.metaMessages, ""] : [],
      ...o ? [
        `Docs: ${this.docsBaseUrl}${o}.html${i.docsSlug ? `#${i.docsSlug}` : ""}`
      ] : [],
      ...a ? [`Details: ${a}`] : [],
      `Version: ${this.version}`
    ].join(`
`), i.cause && (this.cause = i.cause), this.details = a, this.docsPath = o, this.metaMessages = i.metaMessages, this.shortMessage = t;
  }
  walk(t) {
    return V1(this, h0, "m", J1).call(this, this, t);
  }
}
h0 = /* @__PURE__ */ new WeakSet(), J1 = function e(t, i) {
  return i?.(t) ? t : t.cause ? V1(this, h0, "m", e).call(this, t.cause, i) : t;
};
class Y1 extends V2 {
  constructor() {
    super("Chain not configured."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ChainNotConfiguredError"
    });
  }
}
class I2 extends V2 {
  constructor() {
    super("Provider not found."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ProviderNotFoundError"
    });
  }
}
const ln = /(rabby|trustwallet)/, dn = {
  coinbaseWallet: {
    id: "coinbaseWallet",
    name: "Coinbase Wallet",
    provider(e) {
      return e?.coinbaseWalletExtension ? e.coinbaseWalletExtension : u0(e, "isCoinbaseWallet");
    }
  },
  metaMask: {
    id: "metaMask",
    name: "MetaMask",
    provider(e) {
      return u0(e, (t) => {
        if (!t.isMetaMask || t.isBraveWallet && !t._events && !t._state)
          return !1;
        const i = [
          "isApexWallet",
          "isAvalanche",
          "isBitKeep",
          "isBlockWallet",
          "isKuCoinWallet",
          "isMathWallet",
          "isOkxWallet",
          "isOKExWallet",
          "isOneInchIOSWallet",
          "isOneInchAndroidWallet",
          "isOpera",
          "isPortal",
          "isRabby",
          "isTokenPocket",
          "isTokenary",
          "isZerion"
        ];
        for (const a of i)
          if (t[a])
            return !1;
        return !0;
      });
    }
  },
  phantom: {
    id: "phantom",
    name: "Phantom",
    provider(e) {
      return e?.phantom?.ethereum ? e.phantom?.ethereum : u0(e, "isPhantom");
    }
  }
};
q0.type = "injected";
function q0(e = {}) {
  const { shimDisconnect: t = !0, unstable_shimAsyncInject: i } = e;
  function a() {
    const d = e.target;
    if (typeof d == "function") {
      const l = d();
      if (l)
        return l;
    }
    return typeof d == "object" ? d : typeof d == "string" ? {
      ...dn[d] ?? {
        id: d,
        name: `${d[0].toUpperCase()}${d.slice(1)}`,
        provider: `is${d[0].toUpperCase()}${d.slice(1)}`
      }
    } : {
      id: "injected",
      name: "Injected",
      provider(l) {
        return l?.ethereum;
      }
    };
  }
  let o, s, f, p;
  return (d) => ({
    get icon() {
      return a().icon;
    },
    get id() {
      return a().id;
    },
    get name() {
      return a().name;
    },
    get supportsSimulation() {
      return ln.test(this.id.toLowerCase());
    },
    type: q0.type,
    async setup() {
      const l = await this.getProvider();
      l && e.target && (f || (f = this.onConnect.bind(this), l.on("connect", f)), o || (o = this.onAccountsChanged.bind(this), l.on("accountsChanged", o)));
    },
    async connect({ chainId: l, isReconnecting: u } = {}) {
      const b = await this.getProvider();
      if (!b)
        throw new I2();
      let x = [];
      if (u)
        x = await this.getAccounts().catch(() => []);
      else if (t)
        try {
          x = (await b.request({
            method: "wallet_requestPermissions",
            params: [{ eth_accounts: {} }]
          }))[0]?.caveats?.[0]?.value?.map((v) => N(v));
        } catch (w) {
          const v = w;
          if (v.code === R.code)
            throw new R(v);
          if (v.code === w0.code)
            throw v;
        }
      try {
        !x?.length && !u && (x = (await b.request({
          method: "eth_requestAccounts"
        })).map((C) => N(C))), f && (b.removeListener("connect", f), f = void 0), o || (o = this.onAccountsChanged.bind(this), b.on("accountsChanged", o)), s || (s = this.onChainChanged.bind(this), b.on("chainChanged", s)), p || (p = this.onDisconnect.bind(this), b.on("disconnect", p));
        let w = await this.getChainId();
        return l && w !== l && (w = (await this.switchChain({ chainId: l }).catch((C) => {
          if (C.code === R.code)
            throw C;
          return { id: w };
        }))?.id ?? w), t && await d.storage?.removeItem(`${this.id}.disconnected`), e.target || await d.storage?.setItem("injected.connected", !0), { accounts: x, chainId: w };
      } catch (w) {
        const v = w;
        throw v.code === R.code ? new R(v) : v.code === w0.code ? new w0(v) : v;
      }
    },
    async disconnect() {
      const l = await this.getProvider();
      if (!l)
        throw new I2();
      s && (l.removeListener("chainChanged", s), s = void 0), p && (l.removeListener("disconnect", p), p = void 0), f || (f = this.onConnect.bind(this), l.on("connect", f));
      try {
        await l.request({
          // `'wallet_revokePermissions'` added in `viem@2.10.3`
          method: "wallet_revokePermissions",
          params: [{ eth_accounts: {} }]
        });
      } catch {
      }
      t && await d.storage?.setItem(`${this.id}.disconnected`, !0), e.target || await d.storage?.removeItem("injected.connected");
    },
    async getAccounts() {
      const l = await this.getProvider();
      if (!l)
        throw new I2();
      return (await l.request({ method: "eth_accounts" })).map((b) => N(b));
    },
    async getChainId() {
      const l = await this.getProvider();
      if (!l)
        throw new I2();
      const u = await l.request({ method: "eth_chainId" });
      return Number(u);
    },
    async getProvider() {
      if (typeof window > "u")
        return;
      let l;
      const u = a();
      return typeof u.provider == "function" ? l = u.provider(window) : typeof u.provider == "string" ? l = u0(window, u.provider) : l = u.provider, l && !l.removeListener && ("off" in l && typeof l.off == "function" ? l.removeListener = l.off : l.removeListener = () => {
      }), l;
    },
    async isAuthorized() {
      try {
        if (t && // If shim exists in storage, connector is disconnected
        await d.storage?.getItem(`${this.id}.disconnected`) || !e.target && !await d.storage?.getItem("injected.connected"))
          return !1;
        if (!await this.getProvider()) {
          if (i !== void 0 && i !== !1) {
            const x = async () => (typeof window < "u" && window.removeEventListener("ethereum#initialized", x), !!await this.getProvider()), w = typeof i == "number" ? i : 1e3;
            if (await Promise.race([
              ...typeof window < "u" ? [
                new Promise((C) => window.addEventListener("ethereum#initialized", () => C(x()), { once: !0 }))
              ] : [],
              new Promise((C) => setTimeout(() => C(x()), w))
            ]))
              return !0;
          }
          throw new I2();
        }
        return !!(await ge(() => this.getAccounts())).length;
      } catch {
        return !1;
      }
    },
    async switchChain({ addEthereumChainParameter: l, chainId: u }) {
      const b = await this.getProvider();
      if (!b)
        throw new I2();
      const x = d.chains.find((w) => w.id === u);
      if (!x)
        throw new s2(new Y1());
      try {
        return await Promise.all([
          b.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: c2(u) }]
          }).then(async () => {
            await this.getChainId() === u && d.emitter.emit("change", { chainId: u });
          }),
          new Promise((w) => d.emitter.once("change", ({ chainId: v }) => {
            v === u && w();
          }))
        ]), x;
      } catch (w) {
        const v = w;
        if (v.code === 4902 || // Unwrapping for MetaMask Mobile
        // https://github.com/MetaMask/metamask-mobile/issues/2944#issuecomment-976988719
        v?.data?.originalError?.code === 4902)
          try {
            const { default: C, ...B } = x.blockExplorers ?? {};
            let F;
            l?.blockExplorerUrls ? F = l.blockExplorerUrls : C && (F = [
              C.url,
              ...Object.values(B).map((M) => M.url)
            ]);
            let I;
            l?.rpcUrls?.length ? I = l.rpcUrls : I = [x.rpcUrls.default?.http[0] ?? ""];
            const S = {
              blockExplorerUrls: F,
              chainId: c2(u),
              chainName: l?.chainName ?? x.name,
              iconUrls: l?.iconUrls,
              nativeCurrency: l?.nativeCurrency ?? x.nativeCurrency,
              rpcUrls: I
            };
            if (await b.request({
              method: "wallet_addEthereumChain",
              params: [S]
            }), await this.getChainId() !== u)
              throw new R(new Error("User rejected switch after adding network."));
            return x;
          } catch (C) {
            throw new R(C);
          }
        throw v.code === R.code ? new R(v) : new s2(v);
      }
    },
    async onAccountsChanged(l) {
      if (l.length === 0)
        this.onDisconnect();
      else if (d.emitter.listenerCount("connect")) {
        const u = (await this.getChainId()).toString();
        this.onConnect({ chainId: u }), t && await d.storage?.removeItem(`${this.id}.disconnected`);
      } else
        d.emitter.emit("change", {
          accounts: l.map((u) => N(u))
        });
    },
    onChainChanged(l) {
      const u = Number(l);
      d.emitter.emit("change", { chainId: u });
    },
    async onConnect(l) {
      const u = await this.getAccounts();
      if (u.length === 0)
        return;
      const b = Number(l.chainId);
      d.emitter.emit("connect", { accounts: u, chainId: b });
      const x = await this.getProvider();
      x && (f && (x.removeListener("connect", f), f = void 0), o || (o = this.onAccountsChanged.bind(this), x.on("accountsChanged", o)), s || (s = this.onChainChanged.bind(this), x.on("chainChanged", s)), p || (p = this.onDisconnect.bind(this), x.on("disconnect", p)));
    },
    async onDisconnect(l) {
      const u = await this.getProvider();
      l && l.code === 1013 && u && (await this.getAccounts()).length || (d.emitter.emit("disconnect"), u && (s && (u.removeListener("chainChanged", s), s = void 0), p && (u.removeListener("disconnect", p), p = void 0), f || (f = this.onConnect.bind(this), u.on("connect", f))));
    }
  });
}
function u0(e, t) {
  function i(o) {
    return typeof t == "function" ? t(o) : typeof t == "string" ? o[t] : !0;
  }
  const a = e.ethereum;
  if (a?.providers)
    return a.providers.find((o) => i(o));
  if (a && i(a))
    return a;
}
function l1(e, t, i, a, o, s, f) {
  try {
    var p = e[s](f), d = p.value;
  } catch (l) {
    i(l);
    return;
  }
  p.done ? t(d) : Promise.resolve(d).then(a, o);
}
function Y(e) {
  return function() {
    var t = this, i = arguments;
    return new Promise(function(a, o) {
      var s = e.apply(t, i);
      function f(d) {
        l1(s, a, o, f, p, "next", d);
      }
      function p(d) {
        l1(s, a, o, f, p, "throw", d);
      }
      f(void 0);
    });
  };
}
function X1(e, t, i) {
  return t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = i, e;
}
function I0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {}, a = Object.keys(i);
    typeof Object.getOwnPropertySymbols == "function" && (a = a.concat(Object.getOwnPropertySymbols(i).filter(function(o) {
      return Object.getOwnPropertyDescriptor(i, o).enumerable;
    }))), a.forEach(function(o) {
      X1(e, o, i[o]);
    });
  }
  return e;
}
function pn(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    i.push.apply(i, a);
  }
  return i;
}
function d1(e, t) {
  return t = t ?? {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : pn(Object(t)).forEach(function(i) {
    Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
  }), e;
}
function gn(e) {
  "@swc/helpers - typeof";
  return e && typeof Symbol < "u" && e.constructor === Symbol ? "symbol" : typeof e;
}
function X(e, t) {
  var i, a, o, s, f = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] };
  return s = { next: p(0), throw: p(1), return: p(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function p(l) {
    return function(u) {
      return d([l, u]);
    };
  }
  function d(l) {
    if (i) throw new TypeError("Generator is already executing.");
    for (; f; ) try {
      if (i = 1, a && (o = l[0] & 2 ? a.return : l[0] ? a.throw || ((o = a.return) && o.call(a), 0) : a.next) && !(o = o.call(a, l[1])).done) return o;
      switch (a = 0, o && (l = [l[0] & 2, o.value]), l[0]) {
        case 0:
        case 1:
          o = l;
          break;
        case 4:
          return f.label++, { value: l[1], done: !1 };
        case 5:
          f.label++, a = l[1], l = [0];
          continue;
        case 7:
          l = f.ops.pop(), f.trys.pop();
          continue;
        default:
          if (o = f.trys, !(o = o.length > 0 && o[o.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            f = 0;
            continue;
          }
          if (l[0] === 3 && (!o || l[1] > o[0] && l[1] < o[3])) {
            f.label = l[1];
            break;
          }
          if (l[0] === 6 && f.label < o[1]) {
            f.label = o[1], o = l;
            break;
          }
          if (o && f.label < o[2]) {
            f.label = o[2], f.ops.push(l);
            break;
          }
          o[2] && f.ops.pop(), f.trys.pop();
          continue;
      }
      l = t.call(e, f);
    } catch (u) {
      l = [6, u], a = 0;
    } finally {
      i = o = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}
W0.type = "binanceWallet";
function W0() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t;
  return function(i) {
    return { id: "wallet.binance.com", name: "Binance Wallet", type: W0.type, setup: function() {
      return Y(function() {
        var o;
        return X(this, function(s) {
          switch (s.label) {
            case 0:
              return [4, this.getProvider()];
            case 1:
              return o = s.sent(), o && o.on("connect", this.onConnect.bind(this)), [2];
          }
        });
      }).apply(this);
    }, connect: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = o.chainId;
      return Y(function() {
        var f, p, d;
        return X(this, function(l) {
          switch (l.label) {
            case 0:
              return s = s ?? 56, [4, this.getProvider({ chainId: s })];
            case 1:
              return f = l.sent(), f.on("accountsChanged", this.onAccountsChanged.bind(this)), f.on("chainChanged", this.onChainChanged.bind(this)), f.on("disconnect", this.onDisconnect.bind(this)), setTimeout(function() {
                return i.emitter.emit("message", { type: "connecting" });
              }, 0), f.setLng(e.lng || "en"), [4, f.enable()];
            case 2:
              return p = l.sent().map(function(u) {
                return N(u);
              }), [4, this.getChainId()];
            case 3:
              return d = l.sent(), [2, { accounts: p, chainId: d }];
          }
        });
      }).apply(this);
    }, disconnect: function() {
      return Y(function() {
        var o;
        return X(this, function(s) {
          switch (s.label) {
            case 0:
              return [4, this.getProvider()];
            case 1:
              return o = s.sent(), o.disconnect(), o.removeListener("accountsChanged", this.onAccountsChanged), o.removeListener("chainChanged", this.onChainChanged), o.removeListener("disconnect", this.onDisconnect), [2];
          }
        });
      }).apply(this);
    }, getAccounts: function() {
      return Y(function() {
        return X(this, function(o) {
          switch (o.label) {
            case 0:
              return [4, this.getProvider()];
            case 1:
              return [4, o.sent().request({ method: "eth_accounts" })];
            case 2:
              return [2, o.sent().map(function(s) {
                return N(s);
              })];
          }
        });
      }).apply(this);
    }, getChainId: function() {
      return Y(function() {
        var o, s, f, p;
        return X(this, function(d) {
          switch (d.label) {
            case 0:
              return [4, this.getProvider()];
            case 1:
              return s = d.sent(), (o = s.chainId) !== null && o !== void 0 ? (p = o, [3, 4]) : [3, 2];
            case 2:
              return [4, s?.request({ method: "eth_chainId" })];
            case 3:
              p = d.sent(), d.label = 4;
            case 4:
              return f = p, [2, E0(f)];
          }
        });
      }).apply(this);
    }, getProvider: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = o.chainId;
      return Y(function() {
        var f, p, d, l, u;
        return X(this, function(b) {
          switch (b.label) {
            case 0:
              return (typeof window > "u" ? "undefined" : gn(window)) > "u" ? [2] : [4, import("./index-CTcSucCX.js")];
            case 1:
              return d = b.sent().default, l = s || ((f = i.chains[0]) === null || f === void 0 ? void 0 : f.id), u = e.infuraId ? {} : i.chains.reduce(function(x, w) {
                return d1(I0({}, x), X1({}, w.id, w.rpcUrls.default.http[0]));
              }, {}), [2, (t = new d(d1(I0({}, e), { chainId: l, rpc: I0({}, u, (p = this.options) === null || p === void 0 ? void 0 : p.rpc) })), t)];
          }
        });
      }).apply(this);
    }, isAuthorized: function() {
      return Y(function() {
        return X(this, function(o) {
          switch (o.label) {
            case 0:
              return o.trys.push([0, 2, , 3]), [4, this.getAccounts()];
            case 1:
              return [2, o.sent().length > 0];
            case 2:
              return o.sent(), [2, !1];
            case 3:
              return [2];
          }
        });
      }).apply(this);
    }, switchChain: function(a) {
      var o = a.chainId;
      return Y(function() {
        var s, f, p, d, l;
        return X(this, function(u) {
          switch (u.label) {
            case 0:
              if (s = i.chains.find(function(b) {
                return b.id === o;
              }), !s) throw new s2(new Y1());
              return [4, this.getProvider()];
            case 1:
              f = u.sent(), p = c2(s.id), u.label = 2;
            case 2:
              return u.trys.push([2, 4, , 5]), [4, Promise.race([f.request({ method: "wallet_switchEthereumChain", params: [{ chainId: p }] }), new Promise(function(b) {
                return i.emitter.once("change", function(x) {
                  var w = x.chainId;
                  w === o && b(o);
                });
              })])];
            case 3:
              return [2, (u.sent(), s)];
            case 4:
              throw d = u.sent(), l = typeof d == "string" ? d : d?.message, /user rejected request/i.test(l) ? new R(d) : new s2(d);
            case 5:
              return [2];
          }
        });
      }).apply(this);
    }, onAccountsChanged: function(a) {
      a.length === 0 ? i.emitter.emit("disconnect") : i.emitter.emit("change", { accounts: a.map(function(o) {
        return N(o);
      }) });
    }, onChainChanged: function(a) {
      var o = E0(a);
      i.emitter.emit("change", { chainId: o });
    }, onConnect: function(a) {
      return Y(function() {
        var o, s, f;
        return X(this, function(p) {
          switch (p.label) {
            case 0:
              return [4, this.getAccounts()];
            case 1:
              return o = p.sent(), o.length === 0 ? [2] : (s = E0(a.chainId), i.emitter.emit("connect", { accounts: o, chainId: s }), [4, this.getProvider()]);
            case 2:
              return f = p.sent(), f && (f.removeListener("connect", this.onConnect.bind(this)), f.on("accountsChanged", this.onAccountsChanged.bind(this)), f.on("chainChanged", this.onChainChanged), f.on("disconnect", this.onDisconnect.bind(this))), [2];
          }
        });
      }).apply(this);
    }, onDisconnect: function(a) {
      return Y(function() {
        var o;
        return X(this, function(s) {
          switch (s.label) {
            case 0:
              return i.emitter.emit("disconnect"), [4, this.getProvider()];
            case 1:
              return o = s.sent(), o.removeListener("accountsChanged", this.onAccountsChanged.bind(this)), o.removeListener("chainChanged", this.onChainChanged), o.removeListener("disconnect", this.onDisconnect.bind(this)), o.on("connect", this.onConnect.bind(this)), [2];
          }
        });
      }).apply(this);
    } };
  };
}
var mn = function() {
  return un() ? q0 : W0;
};
const bn = "data:image/svg+xml,%3csvg%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cg%20clip-path='url(%23a)'%20fill='%23F3BA2F'%3e%3cpath%20d='m7.107%209.775%204.52-4.52%204.52%204.52%202.628-2.628L11.627%200%204.48%207.147l2.627%202.628ZM2.624%209.007%200%2011.63l2.624%202.625L5.25%2011.63%202.624%209.007ZM7.107%2013.486l4.52%204.52%204.52-4.52%202.628%202.628-7.148%207.147-7.147-7.147%202.627-2.628ZM20.63%209.007l-2.625%202.625%202.625%202.624%202.624-2.624-2.624-2.625Z'/%3e%3cpath%20d='m14.292%2011.63-2.664-2.663-1.966%201.966-.239.22-.46.478%202.665%202.664%202.664-2.664Z'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='a'%3e%3cpath%20fill='%23fff'%20d='M0%200h24v24H0z'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", xn = mn(), wn = (e) => g2((t) => ({
  ...xn(e)(t),
  imageSrc: bn
})), yn = le(), Q1 = [
  m1,
  g1,
  ve,
  Ce
], vn = Object.fromEntries(Q1.map((e) => [e.id, me()])), Cn = be({
  chains: Q1,
  transports: vn,
  multiInjectedProviderDiscovery: !1,
  connectors: [
    ...yn ? [] : [
      Ie(),
      Se()
    ],
    wn(),
    Fe({ appName: "Swapin" }),
    Pe({
      projectId: "7a4f8ad947d7cd10dfafdc64c69a267d",
      qrModalOptions: {
        explorerExcludedWalletIds: "ALL",
        explorerRecommendedWalletIds: [
          "c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96",
          // MetaMask
          "4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0",
          // Trust Wallet
          "8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4",
          // Binance Web3 Wallet
          "bc949c5d968ae81310268bf9193f9c9fb7bb4e1283e1284af8f2bd4992535fd6",
          // Argent
          "1ae92b26df02f0abca6304df07debccd18262fdf5fe82daa81593582dac9a369",
          // Rainbow
          "e9ff15be73584489ca4a66f64d32c4537711797e30b6660dbcb71ea72a42b1f4",
          // Exodus
          "19177a98252e07ddfc9af2083ba8e07ef627cb6103467ffebb3f8f4205fd7927",
          // Ledger Live
          "2a3c89040ac3b723a1972a33a125b1db11e258a6975d3a61252cd64e6ea5ea01",
          // Coin98 Super App
          "1f69170bf7a9bdcf89403ec012659b7124e158f925cdd4a2be49274c24cf5e5d",
          // CoolWallet
          "f2436c67184f158d1beda5df53298ee84abfc367581e4505134b5bcf5f46697d"
          // Crypto.com | DeFi Wallet
        ],
        themeVariables: {
          "--wcm-z-index": "1100"
        }
      }
    })
  ]
}), i4 = {
  install: (e) => {
    e.use(xe, { config: Cn });
  }
};
export {
  e4 as A,
  W as B,
  Sn as C,
  un as D,
  E0 as E,
  Nn as F,
  kn as G,
  On as H,
  jn as I,
  it as J,
  J2 as K,
  d0 as L,
  An as M,
  i4 as N,
  Pn as Q,
  wr as W,
  Ln as a,
  $n as b,
  Tn as c,
  sn as d,
  Rn as e,
  r4 as f,
  n4 as g,
  cn as h,
  Vn as i,
  Hn as j,
  Gn as k,
  qn as l,
  Mn as m,
  Kn as n,
  Yn as o,
  Xn as p,
  Fn as q,
  Jn as r,
  Qn as s,
  en as t,
  t4 as u,
  zn as v,
  Zn as w,
  Wn as x,
  Dn as y,
  Un as z
};
